/*  jfd*******************************
 *   contains breachbits helper functions
     ********************************** */
import {Store} from 'react-notifications-component';
import IntlMessages from "./IntlMessages";
import React, {useState} from "react";
import {
    SUCCESS,
    DEFAULT,
    WARNING,
    INFO,
    DANGER,
    CUSTOM
} from "../constants/ActionTypes";
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../components/customBreachBits/accents/BRCustomizedTooltip";
import GpsOffSharpIcon from "@material-ui/icons/GpsOffSharp";
import GpsFixedSharpIcon from "@material-ui/icons/GpsFixedSharp";
import BBIconLoadError from "../assets/bbCustomIcons/BBIconLoadError";
import BBIconConstructionCone from "../assets/bbCustomIcons/BBIconConstructionCone";
import BBIconRiskDirectionUp from "../assets/bbCustomIcons/BBIconRiskDirectionUp";
import BBIconRiskDirectionUpHalf from "../assets/bbCustomIcons/BBIconRiskDirectionUpHalf";
import BBIconRiskDirectionDownHalf from "../assets/bbCustomIcons/BBIconRiskDirectionDownHalf";
import BBIconRiskDirectionDown from "../assets/bbCustomIcons/BBIconRiskDirectionDown";
import BBIconRiskDirectionUpAndDown from "../assets/bbCustomIcons/BBIconRiskDirectionUpAndDown";
import BBIconRiskDirectionRight from "../assets/bbCustomIcons/BBIconRiskDirectionRight";
import {Badge} from "reactstrap";
import BBIconHexModuleMonitor from "../assets/bbCustomIcons/BBIconHexModuleMonitor";
import BBIconHexModuleExternalThreat from "../assets/bbCustomIcons/BBIconHexModuleExternalThreat";
import BBIconHexModuleInsiderThreat from "../assets/bbCustomIcons/BBIconHexModuleInsiderThreat";
import BBIconHexModuleSocial from "../assets/bbCustomIcons/BBIconHexModuleSocial";
import BBIconHexModuleCompliance from "../assets/bbCustomIcons/BBIconHexModuleCompliance";
import BBIconHexQuestion from "../assets/bbCustomIcons/BBIconHexQuestion";
import ExitToAppSharpIcon from "@material-ui/icons/ExitToAppSharp";
import BBIconShieldSimpleCheck from "../assets/bbCustomIcons/BBIconShieldSimpleCheck";
import BBIconShieldSimpleWarning from "../assets/bbCustomIcons/BBIconShieldSimpleWarning";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import BBIconLockBasic from "../assets/bbCustomIcons/BBIconLockBasic";
// import {Link, } from "react-router-dom";
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../components/customBreachBits/accents/BBExternalLink";
import BBIconExpiredClock from "../assets/bbCustomIcons/BBIconExpiredClock";
import OwnershipRequiredPopper from "../components/customBreachBits/OnboardingProgress/OwnershipRequiredPopper";
import BRBusinessAttacksAuthorizedToggleSwitchWidget
    from "../components/customBreachBits/controllers/BRBusinessAttacksAuthorizedControlWidget";
import BRSocialEngineeringAuthorizationWidget
    from "../components/customBreachBits/BRSocialReports/BRSocialEngineeringAuthorizationWidget";
import OnboardingItemNotApplicableButton
    from "../components/customBreachBits/OnboardingProgress/OnboardingItemNotApplicable";
import BBIconTechData from "../assets/bbCustomIcons/BBIconTechData";
import BBIconGraphChart from "../assets/bbCustomIcons/BBIconGraphChart";
import BBIconAccountTrustedAgent from "../assets/bbCustomIcons/BBIconAccountTrustedAgent";
import BBIconBreachRiskScore from "../assets/bbCustomIcons/BBIconBreachRiskScore";


/**
 * Summary. (use period)
 *
 * Description. Looks at the authUser in the store, examines the roles, and determines if the given role is present.
 * name: admin , id: 1
 * name: staff , id: 2
 *
 * @param {Object}   authUserRoles       authUser Object containing role objects. Assumes contains roles-> .id and .name
 * @param {number}   containsRole        The id or name from the API that corresponds to a roleId or role name.
 * @param {string}   containsRole        Description of optional variable.
 *
 * @return {boolean} True if current user has the given roleId or role name, false otherwise
 *
 * @example  isCurrentUserMemberOf(authUser, "admin"); //returns true if current user has the admin role
 */
export const isCurrentUserMemberOf = (authUserRoles, containsRole) => {

    if (!authUserRoles || !authUserRoles.roles || !containsRole){
        console.warn("Attempted to check isCurrentUserMemberOf using undefined values:", authUserRoles, containsRole);
        return false;
    }

    if (typeof(containsRole) !== "number" && typeof(containsRole) !== "string") {
        console.warn("Attempted to check isCurrentUserMemberOf using containsRole of types not a string or number", containsRole);
        return false;
    }

    //get array of the names of the roles
    const roleNames = authUserRoles.roles.map(role => role.role.name);
    //console.log("roleNames found:", roleNames);

    //get array of the ids of the roles
    const roleIds = authUserRoles.roles.map(role => role.role.id);
    // console.log("roleIds found:", roleIds);

    switch (typeof(containsRole)) {
        case "number":
            return roleIds.includes(containsRole);
        case "string":
            return roleNames.includes(containsRole);
        default:
            console.warn("Unable to find", containsRole, roleNames, roleIds)
            return false;
    }

}

/**
 * Summary. getInViewCustomerObject
 *
 * Description. Uses the customerInView state and returns a customer object
 *
 * @param {number}   fromId        the CustomerId you want
 * @param {array}    fromCustomers the state array of customers
 *
 * @return {object} A customer object (of the one in view)
 *
 * @example  getInViewCustomerObject(1234, [customers]);
 */
export const getCustomerObject = (fromId, fromCustomers) => {

    try {
        const customer = fromCustomers.filter((c) => c.CustomerId === fromId)[0];
        console.log("Filtered out customers and got in BreachBoardContent: ", customer);
        return customer;
    } catch {
        console.warn("Failed to extract a customer from ", fromCustomers);
        return null;
    }
}

/**
 * Summary. getFirstCustomerId
 *
 * Description. Takes an array of customer objects and returns the first customer ID
 *
 * @param {object}    fromCustomers the state array of customers
 *
 * @return {string} A customer object (of the one in view)
 *
 * @example  getInViewCustomerObject(1234, [customers]);
 */
export const getFirstCustomerId = (fromCustomers) => {
    // console.log("Getting the first ID from this list of customers ", fromCustomers);
    // console.log(fromCustomers[0]);
    // const id = Object.keys(fromCustomers)[0];
    // return id;
    if(fromCustomers && bbIsObject(fromCustomers)) {
        try {
            const customers = fromCustomers;
            const sortedCustomers =  customers ? Object.keys(customers).map((k) => customers[k]) : [];
            sortedCustomers.sort(function(a, b) {
                const textA = a.CustomerName.toUpperCase();
                const textB = b.CustomerName.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            return sortedCustomers.length ? sortedCustomers[0].CustomerId : null;
        } catch(e) {
            console.warn("sorting customers and getting first one failed.", e)
            return null;
        }
    } else {
        return null;
    }
}

/**
 * Summary. getFirstEntityId
 *
 * Description. Takes an object of entity objects and returns the first entity ID. Similar to getFirstCustomerId but for BRP
 *
 * @param {object}    fromEntities the state object of customers
 *
 * @return {string} A customer object (of the one in view)
 *
 * @example  getFirstEntityId(customers[customerInView].entities);
 */
export const getFirstEntityId = (fromEntities) => {
    // console.log("Getting the first ID from this list of customers ", fromCustomers);
    // console.log(fromCustomers[0]);
    // const id = Object.keys(fromCustomers)[0];
    // return id;
    if(fromEntities && bbIsObject(fromEntities)) {
        try {
            const entities = fromEntities;
            const sortedEntities =  entities ? Object.keys(entities).map((k) => entities[k]) : [];
            sortedEntities.sort(function(a, b) {
                const textA = a.name.toUpperCase();
                const textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            return sortedEntities.length ? sortedEntities[0].id : null;
        } catch(e) {
            console.warn("sorting entities and getting first one failed.", e)
            return null;
        }
    } else {
        return null;
    }
}

/*  jfd*******************************
 *   Class checkers. citation: https://stackoverflow.com/questions/33199959/how-to-detect-a-react-component-vs-a-react-element
     ********************************** */

export function isClassComponent(component) {
    return (
        typeof component === 'function' &&
        !!component.prototype.isReactComponent
    )
}

export function isFunctionComponent(component) {
    return (
        typeof component === 'function' &&
        String(component).includes('return React.createElement')
    )
}

export function isReactComponent(component) {
    return (
        isClassComponent(component) ||
        isFunctionComponent(component)
    )
}

export function isReactComponentNamed(component, named) {
    // console.log("Component is: ", component);
    // console.log("Component name is: ", component.type.displayName);
    // console.log("Looking for: ", named, component.type.displayName === named);
    // console.log("isClassComponent(component) : ", isClassComponent(component));
    // console.log("isFunctionComponent(component) : ", isFunctionComponent(component));
    return (
        (
            (isClassComponent(component) || isFunctionComponent(component))
            && component.type.displayName === named)
    )
}

export function isElement(element) {
    return React.isValidElement(element);
}

export function isElementNamed(element, named) {
    // console.log("element is: ", element);
    // console.log("element name is: ", element.type.displayName);
    // console.log("Looking for: ", named, element.type.displayName === named);
    // console.log("React.isValidElement(element) : ", React.isValidElement(element));
    return (
        (
            (React.isValidElement(element))
            && element.type.displayName === named)
    )
}

export function isDOMTypeElement(element) {
    return isElement(element) && typeof element.type === 'string';
}

export function isCompositeTypeElement(element) {
    return isElement(element) && typeof element.type === 'function';
}



/*  jfd*******************************
 *   Showing notification/messages
     ********************************** */

/**
 * Summary. (use period)
 *
 * Description. A wrapper for the react-notifications-component function, to simplify calls and keep the default settings consistent across the app.
 *
 * @param {Object}   title        TAn <IntlMessages id={"signIn.error.network"}/> formed object
 * @param {string}   title        String for the title line.
 * @param {Object}   message      An <IntlMessages id={"signIn.error.network"}/> formed object
 * @param {string}   message      String for the message line.
 * @param {string}   type         SUCCESS, DEFAULT, WARNING, INFO, DANGER, or CUSTOM (constant)
 * @param {boolean}  persist      If true, overrides that type's dismiss behavior, keeping it on the screen.
 *
 * @return {none} No return value.
 *
 * @example  showBBNotification(ERROR, <IntlMessages id={"signIn.error.network"}/>, <IntlMessages id={"signIn.error.network.detail"}/>); //displays an error message
 */
export const showBBNotification = (type, title, message, persist = false) => {

    // console.group("Showing a", type, " notification. title: ", title, " message: ", message, " should it persist? ", persist);

    //defaults
    let container = "top-right";
    /*  jfd**********22.Dec.09.21:20*****
     *   pretty sure the following animations are broken and not really connecting to animate.css
         ********************** `--===<>==<>==C>-< */
    let animationIn = ['animate__animated animate__fadeInUp'] //["animated", "fadeIn"]; //
    let animationOut = ['animate__animated animate__fadeOutRight'] //["animated", "fadeOutRight"]; //
    let dismissDuration = 20000; //0 for infinite
    let dismissOnScreen = true; //shows the notification timer
    let dismissShowIcon = true; //shows the x to kill
    let dismissPauseOnHover = true; //hovering over will pause the timer
    let messageType = DEFAULT;

    //check the given message type and adjust the settings based on that type
    switch (type){
        case SUCCESS:
            messageType = SUCCESS;
            dismissDuration = 10000;
            dismissOnScreen = false;
            break;

        case DEFAULT:
            messageType = DEFAULT;
            break;

        case WARNING:
            messageType = WARNING;
            dismissDuration = 20000;
            break;

        case INFO:
            messageType = INFO;
            dismissOnScreen = true;
            dismissDuration = 7000;
            break;

        case DANGER:
            messageType = DANGER;
            break;

        case CUSTOM:
            messageType = DEFAULT; //No customazation support yet. Use default.
            break;

        default:
            messageType = DEFAULT;
    }

    if (persist) {
        dismissDuration = 0;
        dismissOnScreen = false;
    }

    //input checking for title and message
    let titleToUse = title;
    let messageToUse = message;

    if (typeof(title) !== "string" && !isElementNamed(title, "injectIntl(InjectMassage)") && !isElementNamed(title, "injectIntl(Component)")) {
        console.warn("Title is of type -->", typeof(title), title, "<-- name check returned: ", isElementNamed(title, "injectIntl(InjectMassage)"));
        titleToUse = <IntlMessages id={"notification.title.generic"}/>;
    }
    if (typeof(message) !== "string" && !isElementNamed(message, "injectIntl(InjectMassage)") && !isElementNamed(title, "injectIntl(Component)")) {
        console.warn("Notification messsage is of type -->", typeof(message), message, "<-- name check returned: ", isElementNamed(title, "injectIntl(InjectMassage)"));
        if (message === null) {
            messageToUse = " "
        } else {
            messageToUse = <IntlMessages id={"notification.message.generic"}/>;
        }
    }

    //send the notification to the screen
    Store.addNotification({
        title: titleToUse,
        message: messageToUse,
        type: messageType,
        container: container,
        // content: <WarningIcon />,
        animationIn: animationIn,
        animationOut: animationOut,
        dismiss: {
            duration: dismissDuration,
            onScreen: dismissOnScreen,
            showIcon: dismissShowIcon,
            pauseOnHover: dismissPauseOnHover,
        }
    });

    // console.groupEnd();
}


/*  jfd*******************************
 *   Functions brought over from BBv1!
     ********************************** */
//TODO: ADD JDOC COMMENTS FOR bbIsValidDateObject
//check to see if an object is a valid date object.  will return false if not a date object OR if not a valid date object
//https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
export const bbIsValidDateObject = (object) => {
    if (Object.prototype.toString.call(object) === "[object Date]") {
        // it is a date
        if (isNaN(object.getTime())) {  // d.valueOf() could also work
            // date is not valid
            return false;
        } else {
            // date is valid
            return true;
        }
    } else {
        // not a date
        return false;
    }
};

/*---- BLUF: bbLegacyDateTimeParseStringToDate ----
 | try to parse the data with format 2020-Jul-06 18:36:08
 | return false if failed or Date object if success
 |_______ ~jfd _________ */

//only used in another helper funciotn, jdoc is not needed

export const bbLegacyDateTimeParseStringToDate = (dateString) => {
    //console.log("Attempting to convert string ", dateString.toString(), " as a legacy string to a Date object.");
    if (dateString.toString()) {
        let returnDate = new Date();

        //get the year month and date
        const ymd = dateString.toString().trim().slice(0, 11).split('-');
        //console.log("Cut up the date string of ", dateString, " to ", ymd);
        if (ymd.length < 3 ||
            ymd[0].length < 4 ||
            ymd[1].length < 2 ||
            !Number.parseInt(ymd[0]) ||
            !Number.parseInt(ymd[2])){ //do some checks
            // console.log("Failed to convert a legacy month from ", dateString, " because it failed initial validation checks. ", ymd);
            return false;
        }

        let monthNum = -1;
        if (!Number.parseInt(ymd[1])) {
            //if the month is not a number, try to set the month
            switch (ymd[1]) {
                case 'Jan':
                    monthNum = 0;
                    break;
                case 'Feb':
                    monthNum = 1;
                    break;
                case 'Mar':
                    monthNum = 2;
                    break;
                case 'Apr':
                    monthNum = 3;
                    break;
                case 'May':
                    monthNum = 4;
                    break;
                case 'Jun':
                    monthNum = 5;
                    break;
                case 'Jul':
                    monthNum = 6;
                    break;
                case 'Aug':
                    monthNum = 7;
                    break;
                case 'Sep':
                    monthNum = 8;
                    break;
                case 'Oct':
                    monthNum = 9;
                    break;
                case 'Nov':
                    monthNum = 10;
                    break;
                case 'Dec':
                    monthNum = 11;
                    break;
                default:
                    // console.log("Failed to convert a legacy month from ", dateString, " using a month parsed input of ", ymd[1]);
                    return false;
            }
        } else if (ymd[1] <= 12 && ymd[1] >= 0) { //it it is a number, then set it.
            monthNum = ymd[1] - 1;
        } else {
            // console.log("Failed to convert a legacy month from ", dateString, " using a month parsed input of ", ymd[1]);
            return false;
        }


        //console.log("Legacy month from ", ymd[1], " converted to ", monthNum);

        // now do the time
        const hmsm = dateString.toString().trim().slice(11).split(':');
        //console.log("Cut up the time string of ", dateString, " to ", hmsm);
        if (hmsm.length !== 3  ||
            hmsm[0].trim().length !== 2 ||
            hmsm[1].length  !== 2
        ){ //do some checks
            // console.log("Failed to convert a legacy time from ", dateString, " because it failed initial validation checks: ", hmsm);
            //   (hmsm.length !== 3),
            //   (hmsm[0].length !== 2 ),
            //   (hmsm[1].length !== 2),
            //   (!Number.parseInt(hmsm[0], 10) ),
            //   (!Number.parseInt(hmsm[1], 10) ), Number.parseInt(hmsm[1], 10),
            //   (!Number.parseInt(hmsm[2], 10) ),
            //   );
            return false;
        }

        //all reasonable checks complete, now convert and try to set

        returnDate.setFullYear(Number.parseInt(ymd[0]), monthNum, Number.parseInt(ymd[2]));
        returnDate.setHours(Number.parseInt(hmsm[0]), Number.parseInt(hmsm[1]), Number.parseInt(hmsm[2]));
        //console.log("Converted a legacy date from ", dateString, ". converted year: ", Number.parseInt(ymd[0]), " converted month: ", monthNum, " converted day: ", Number.parseInt(ymd[2])," to ", returnDate);

        if (isNaN(returnDate)) {
            //console.log("Failed to convert legacy date at last step. failed final validation.", returnDate);
        } else {
            return returnDate;
        }



    } else {
        // console.log("Failed to convert a legacy date from ", dateString, " because could not convert to string.");
        return false;
    }

};

export const bbZeroPad = (num, places) => String(num).padStart(places, '0');

//ref: https://stackoverflow.com/questions/17415579/how-to-iso-8601-format-a-date-with-timezone-offset-in-javascript
const toIsoString = (date, includeTimezone = false) => {
    const tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };

    const datetimePart = date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds());

    const timezonePart = dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);

    //if we are including the timezone, include that, otherwise don't
    const isoDate = includeTimezone ? datetimePart + timezonePart : datetimePart;

    console.log("toIsoString converted date", date, "to ISO format. Output:", isoDate, "was timezone included?", includeTimezone);

    return isoDate;
}

/**
 * Summary. bbNumDaysBetweenDates.
 *
 * Description. Calculates the number of days between dates
 *
 * @param {date}     date1          first date
 * @param {date}     date2          second date. If null, uses now
 *
 * @return {string} in ISO format
 *
 * @example
 */export const bbNumDaysBetweenDates = (date1, date2 = null) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    const firstDate = bbDangerousStringToDate(date1);

    const secondDate = date2 ? date2 : new Date();

    return Math.round(Math.abs((firstDate - secondDate) / oneDay));
}

/**
 * Summary. bbDangerousDateToBBApiDate.
 *
 * Description. Takes current date object and converts it to form that the API will accept. Currently, that is ISO format YYY-MM-DDThh:mm:ss.sTZD (eg 1997-07-16T19:20:30.45Z)
 *
 * @param {date}     date          datetime object
 *
 * @return {string} in ISO format
 *
 * @example
 */
export const bbDangerousDateToBBApiDate = (date) => {
    try {
        // if(date) {
        //     let convert = null;
        //     if(typeof date === "object")
        //     {
        //         //check to see if it's this kind
        //         // Object {
        //         //     _isAMomentObject: true,
        //         //     _i: Date Fri Jun 25 2021 13:47:30 GMT-0400 (Eastern Daylight Time),
        //         //     _isUTC: false,
        //         //     _pf: {…},
        //         //     _locale: {…},
        //         //     _d: Date Fri Sep 24 2021 13:47:00 GMT-0400 (Eastern Daylight Time),
        //         //     _isValid: true
        //         // }
        //
        //         if(bbIsValidDateObject(date._d)) {
        //             convert = bbDangerousStringToDate(date);
        //         } else {
        //             throw `cannot convert ${date} to a date object`;
        //         }
        //
        //     } else {
        //         convert = bbDangerousStringToDate(date);
        //     }
        //
        //     return `${convert.getUTCFullYear()}-${bbZeroPad(convert.getUTCMonth()+1, 2)}-${bbZeroPad(convert.getUTCDate(), 2)} ${convert.getUTCHours()}:${convert.getUTCMinutes()}:${convert.getUTCSeconds()}.${convert.getUTCMilliseconds()}`;
        // } else {
        //     return null;
        // }
        const convert = bbDangerousStringToDate(date.toString());
        //Reference for ISO format: https://www.w3.org/TR/NOTE-datetime
        // const isoDate = `${convert.getUTCFullYear()}-${bbZeroPad(convert.getUTCMonth()+1, 2)}-${bbZeroPad(convert.getUTCDate(), 2)}T${bbZeroPad(convert.getUTCHours(), 2)}:${bbZeroPad(convert.getUTCMinutes(), 2)}:${bbZeroPad(convert.getUTCSeconds(),2)}.${convert.getUTCMilliseconds()}`;

        const isoDate = toIsoString(convert, false);

        return isoDate;
    } catch (e) {
        console.log("error bbDangerousDateToBBApiDate with", date);
        console.log(e);
        return false;
    }
}

//TODO: ADD JDOC COMMENTS FOR bbDangerousStringTODate-- include it's use case vs other date functions
//takes in a string that might not convert to a date, and returns a date or false.  if it is already a valid date object, will return the object back.  if it is not a string or valid date will return false.
export const bbDangerousStringToDate = (dateString, isDateUTC = true) => {

    if (typeof dateString === "string") {
        let convertedDate;
        if (isNaN(Date.parse(dateString.toString()))) { //the format of the input string is invalid, try to use legacy or fail
            convertedDate = bbLegacyDateTimeParseStringToDate(dateString);

            if (!convertedDate) {
                // console.log("Failed when attempted to convert a string to date: ", dateString, " got this when converting: ", Date.parse(dateString));
                return false;
            }

            //console.log("A legacy date : ", dateString, " was successfully converted to: ", convertedDate);
        } else {
            if (isDateUTC) {
                convertedDate = new Date(dateString.toString());
                // console.log(convertedDate.getFullYear(),
                //     convertedDate.getMonth(),
                //     convertedDate.getDate(),
                //     convertedDate.getHours(),
                //     convertedDate.getMinutes(),
                //     convertedDate.getSeconds(),
                //     convertedDate.getMilliseconds());
                convertedDate = new Date(Date.UTC(
                    convertedDate.getFullYear(),
                    convertedDate.getMonth(),
                    convertedDate.getDate(),
                    convertedDate.getHours(),
                    convertedDate.getMinutes(),
                    convertedDate.getSeconds(),
                    convertedDate.getMilliseconds(),
                ));
            } else {
                // this is not a legacy date, so parse it because it must be ISO compliant.... right?

                convertedDate = new Date(dateString.toString());
            }

            //console.log("Date ", dateString, " can be directly converted. Output: ", convertedDate);
        }
        //successfully converted the date, return the date object
        return convertedDate;
    } else if (bbIsValidDateObject(dateString)) {
        //console.log("Attempted to convert a string to date: ", dateString, " but it was already a valid date object.");
        return dateString; //input was already a valid date object
    } else {
        // console.log("bbDangerousStringToDate: Date provided was not a string or date object. ", dateString);
        return false;
    }
};

/*---- BLUF: BBFormattedDate ----
 | accepts a date string and will return a string of that date in the standard BB way.
 |
 |_______ ~jfd _________ */
//TODO: ADD JDOC COMMENTS FOR bbFormattedDateString-- include it's use case vs other date functions

export const bbFormattedDateString = (dateString, size='medium') => {
    // console.log("attempting to format date with bbFormattedDateString", dateString)
    let convertedDate = bbDangerousStringToDate(dateString);
    // console.log("convertedDate is ", convertedDate)
    if (!convertedDate) {
        // console.log("Failed to convert a date using bbDangerousStringToDate. input: ", dateString, " result: ", convertedDate);
        return "--";
    }
    //we have a valid date string, so parse it
    let output;

    switch (size) {
        case 'monthDayTime':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
               month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'long':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                weekday: 'long',
                year: "numeric",
                month: "long",
                day: "2-digit",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "long"
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'UTC':
        case 'utc':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                year: "numeric",
                month: "long",
                day: "2-digit",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short",
                // fractionalSecondDigits: 3,
                hour12: false,
                timeZone:'UTC'
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'medium':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                weekday: 'short',
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric", minute: "numeric",
                timeZoneName: "short"
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'mediumWithSeconds':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                weekday: 'short',
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'short':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                year: "numeric",
                month: "short",
                day: "numeric",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'shortFullMonth':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                year: "numeric",
                month: "long",
                day: "numeric",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'micro':
            output = convertedDate ? new Intl.DateTimeFormat('en-GB', {
                day: "numeric",
                month: "short",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'monthYear':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                month: "long",
                year: "numeric",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;
        case 'monthOnlyShort':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                month: "short",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;

        case 'microYear':
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                day: "numeric",
                month: "short",
                year: "numeric",
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
            break;

        default:
            console.log("Failed to anticipate a format date switch. Using default conversion switch. input: ", dateString, " result: ", convertedDate);
            output = convertedDate ? new Intl.DateTimeFormat('default', {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "numeric", minute: "numeric",
                timeZoneName: "short"
            }).format(convertedDate) : `Input could not be converted to date (${dateString}).`;
    }

    return output;

};

//handles the different kinds of events timestamps, where they are located based on the event type
//used in other function only, no jdoc needed
export const bbAttackEventTimestamp = (eventInfo) => {
    if (eventInfo.eventDateTime) {
        return bbDangerousStringToDate(eventInfo.eventDateTime);
    } else if (eventInfo.emailSent) {
        return bbDangerousStringToDate(eventInfo.emailSent);
    } else if(eventInfo.eventCompleteDateTime) {
        return bbDangerousStringToDate(eventInfo.eventCompleteDateTime);
    } else if(eventInfo.eventTaskedDateTime) {
        return bbDangerousStringToDate(eventInfo.eventTaskedDateTime);
    }
    // console.log("Attempted but failed to convert eventInfo to a Date object: ", eventInfo);
    return null;
};

//TODO: archive unused functions and
/*---- BLUF: bbGetAttackLastActivityDateTime ----
 | this is the core logic that determines whether an attack should be removed based on the last activity.
 |
 |_______ ~jfd _________ */
// export const bbGetAttackLastActivityDateTime = (attack) => {
//
//     const attackTimeline = bbCoreGetAttackTimeline(attack);
//     const events = attackTimeline ? attackTimeline.events : [];
//     if (!events) {
//         console.log("bbGetAttackLastActivityDateTime: Could not access attack timeline of ", attack);
//         return false;
//     }
//
//     // attack last activity is based on the most recent event in the timeline
//     // build an array of all activity dates
//     let activityDates = [];
//
//     //add the PhishSentDateTime if it can convert
//     //activityDates.push(bbDangerousStringToDate(attack.PhishSentDateTime));
//
//     //add the LastCallback if it can convert
//     //activityDates.push(bbDangerousStringToDate(attack.LastCallback));
//
//     //add the AttackIdCreated if it can convert
//     //activityDates.push(bbDangerousStringToDate(attack.AttackIdCreated));
//
//     //get a list of the events, if there are any, and add them to activityDates
//     if( events.length > 0) {
//         //console.log("bbGetAttackLastActivityDateTime: Retrieved attack events: ", events);
//         const sortedTimelineEvents = bbExtractAttackEventInfo(events);
//         (sortedTimelineEvents.length > 0) ? null: console.log("bbGetAttackLastActivityDateTime: Failed to extract timeline events from ", events);
//         for (const event of sortedTimelineEvents) {
//             if (bbDangerousStringToDate(event.ts)) { //if the date is there, put it in the activity Dates array
//                 activityDates.push(event.ts);
//             } else {
//                 console.log("bbGetAttackLastActivityDateTime: Could not harvest a date because it was not a valid date object: ", event.ts, " from ", event);
//             }
//         }
//     } else {
//         console.log("bbGetAttackLastActivityDateTime: No attack events detected in ", events);
//         return false;
//     }
//
//     if (activityDates.length < 1) { //leave if there are no dates
//         console.log("bbGetAttackLastActivityDateTime: No activity dates were harvested from ", attack);
//         return false;
//     }
//
//
//     //console.log("bbGetAttackLastActivityDateTime list of dates ", activityDates);
//     // sort
//     activityDates.sort((a,b) => b - a);
//     //console.log("bbGetAttackLastActivityDateTime SORTED list of dates ", activityDates);
//
//     //get the first item of the array, which should be the newest date
//
//     const latestDate = activityDates[0];
//
//     return latestDate ? latestDate : false; //return the date or false if it was just a false flag
// };








//takes an array of events and extracts some key information and returns an array of eventList objects
export const bbExtractAttackEventInfo = (events) => {

    const eventList = [];

    for(let group_idx = 0; group_idx < events.length; group_idx++) {
        const group_keys = Object.keys(events[group_idx]);
        for(let section_idx = 0; section_idx < group_keys.length; section_idx++) {
            const section_id = group_keys[section_idx];

            const eventInfo = events[group_idx][section_id];

            if ("c2" === section_id) {
                for(let c2_idx = 0; c2_idx < eventInfo.length; c2_idx++) {
                    const c2EventInfo = eventInfo[c2_idx];
                    c2EventInfo.eventTypeId = section_id;
                    c2EventInfo.ts = bbAttackEventTimestamp(c2EventInfo);
                    c2EventInfo.eventTypeName = "C2 Event";
                    eventList.push(c2EventInfo);
                }
            }
            else if( "discovery" === section_id ){
                for(let discover_idx = 0; discover_idx < eventInfo.length; discover_idx++) {
                    const discoverEventInfo = eventInfo[discover_idx];
                    discoverEventInfo.eventTypeId = section_id;
                    discoverEventInfo.ts = bbAttackEventTimestamp(discoverEventInfo);
                    discoverEventInfo.eventTypeName = "Discovery Event";
                    eventList.push(discoverEventInfo);
                }
            }
            else if ("credential" === section_id) {
                for (let credential_idx = 0; credential_idx < eventInfo.length; credential_idx++) {
                    const credentialEventInfo = eventInfo[credential_idx];
                    credentialEventInfo.eventTypeId = section_id;
                    credentialEventInfo.ts = bbAttackEventTimestamp(credentialEventInfo);
                    credentialEventInfo.eventTypeName = "Credential Access Event";
                    eventList.push(credentialEventInfo);
                }
            }
            else if ("persist" === section_id) {
                for (let persistence_idx = 0; persistence_idx < eventInfo.length; persistence_idx++) {
                    const persistenceEventInfo = eventInfo[persistence_idx];
                    persistenceEventInfo.eventTypeId = section_id;
                    persistenceEventInfo.ts = bbAttackEventTimestamp(persistenceEventInfo);
                    persistenceEventInfo.eventTypeName = "Persistence Event";
                    eventList.push(persistenceEventInfo);
                }
            }
            else if ("privesc" === section_id) {
                for (let privesc_idx = 0; privesc_idx < eventInfo.length; privesc_idx++) {
                    const privescEventInfo = eventInfo[privesc_idx];
                    privescEventInfo.eventTypeId = section_id;
                    privescEventInfo.ts = bbAttackEventTimestamp(privescEventInfo);
                    privescEventInfo.eventTypeName = "Privilege Escalation Event";
                    eventList.push(privescEventInfo);
                }
            }
            else if ("evasion" === section_id) {
                for (let evasion_idx = 0; evasion_idx < eventInfo.length; evasion_idx++) {
                    const evasionEventInfo = eventInfo[evasion_idx];
                    evasionEventInfo.eventTypeId = section_id;
                    evasionEventInfo.ts = bbAttackEventTimestamp(evasionEventInfo);
                    evasionEventInfo.eventTypeName = "Defense Evasion Event";
                    eventList.push(evasionEventInfo);
                }
            }
            else if ("lateral" === section_id) {
                for (let lateral_idx = 0; lateral_idx < eventInfo.length; lateral_idx++) {
                    const lateralEventInfo = eventInfo[lateral_idx];
                    lateralEventInfo.eventTypeId = section_id;
                    lateralEventInfo.ts = bbAttackEventTimestamp(lateralEventInfo);
                    lateralEventInfo.eventTypeName = "Lateral Movement Event";
                    eventList.push(lateralEventInfo);
                }
            }
            else if ("collection" === section_id) {
                for (let collection_idx = 0; collection_idx < eventInfo.length; collection_idx++) {
                    const collectionEventInfo = eventInfo[collection_idx];
                    collectionEventInfo.eventTypeId = section_id;
                    collectionEventInfo.ts = bbAttackEventTimestamp(collectionEventInfo);
                    collectionEventInfo.eventTypeName = "Data Collection Event";
                    eventList.push(collectionEventInfo);
                }
            } else { //other event types.  For example, the access and exploit events do not contain an array.
                //console.log("Pushing an unnamed event type to the eventList: ", eventInfo);
                eventInfo.eventTypeId = section_id;
                eventInfo.ts = bbAttackEventTimestamp(eventInfo);
                eventList.push(eventInfo);
            }
        }
    }

    eventList.sort((a,b) => a.ts - b.ts);

    return eventList;
};

/*  jfd*******************************
 *   Other utilities
     ********************************** */

//jfd: credit https://medium.com/sanjagh/iterating-over-javascript-objects-declaratively-or-how-to-map-filter-and-reduce-on-objects-d179cd40d935


/**
 * Summary. filterObject
 *
 * Description. Removes items from the object
 *
 * @param {object}   object           Object to filter
 * @param {function}   fun         The object (_, object), with its filter function.
 *
 * @returns {object}  The object with the filtered out properties removed
 *
 * @example
 * filterObject(stateData, (_, stateData) => stateData.Stromboli["Service Active"] === "1")
 * (or)
 * const myFruits = filterObject(fruits, (_, fruit) => fruit.price <= 2);
 // {
 //     apple: { qty: 300, color: 'green', name: 'apple', price: 2 },
 //     orange: { qty: 120, color: 'orange', name: 'orange', price: 1.5 }
 // }
 */
export const filterObject = (obj, fun) =>{
    if (obj) {
        return Object.entries(obj).reduce(
            (prev, [key, value]) => ({
                ...prev,
                ...(fun(key, value) ? { [key]: value } : {})
            }),
            {}
        );
    } else {
        return null
    }
}


/**
 * Summary. mapObject
 *
 * Description. performs a function over each object
 *
 * @param {object}   object           Object to filter
 * @param {function}   fun         The object (_, object), with its map function.
 *
 * @returns {object}  The object with the map
 *
 * @example
 const myFruits = mapObject(fruits, (_, fruit) => fruit.color);
 /*
 // { apple: 'green',
 //  banana: 'yellow',
 //  orange: 'orange',
 //  melon: 'yellow' }
 */
export const mapObject = (obj, fun) =>
    Object.entries(obj).reduce(
        (prev, [key, value]) => ({
            ...prev,
            [key]: fun(key, value)
        }),
        {}
    );

/**
 * Summary. reduceObject
 *
 * Description. Removes items from the object
 *
 * @param {object}   object           Object to filter
 * @param {function}   fun         The object (obj, fun, initialValue), function.
 *
 * @returns {object}  The object with the map
 *
 * @example
 const myFruits = reduce(fruits, (prev, _, fruit) => [...prev, fruit], []);
 /*
 // [ { qty: 300, color: 'green', name: 'apple', price: 2 },
 // { qty: 130, color: 'yellow', name: 'banana', price: 3 },
 // { qty: 120, color: 'orange', name: 'orange', price: 1.5 },
 // { qty: 70, color: 'yellow', name: 'melon', price: 5 } ]
 */
export const reduceObject = (obj, fun, initialValue) =>
    Object.entries(obj).reduce(
        (prev, [key, value]) => fun(prev, key, value),
        initialValue
    );


/**
 * Summary. bbGetArrayOfVulnsFromObjectOrString
 *
 * Description. gets an array of vulns from an object with a .Vulns paramenter string
 *
 * @param {object}   objectOrString           Object or string to parse
 * @param {string}   objectOrString           Object or string to parse
 *
 * @returns {array}  An array of vulnerabilities parsed.
 *
 * @example
 /*
 vulns = bbGetArrayOfVulnsFromObjectOrString(vulnerability.Vulns);
 //split up the vulns into hyperlinks that open the NVD in a new window
 const vulnsWithHyperlinks = vulns.map((vuln) => (
 <a key={`vulnlink_${vulnerability.IpAddress}_${vulnerability.Fqdn}_${vuln}`} target="_blank" data-toggle="tooltip_link" data-placement="top" title={`External Link: Read about ${vuln} at the NIST National Vulnerability Database.`} href={`https://nvd.nist.gov/vuln/detail/${vuln}`}>{vuln}</a>
 ));
 */
export const bbGetArrayOfVulnsFromObjectOrString = (objectOrString) => {
    if (objectOrString && objectOrString.Vulnerabilities  && typeof objectOrString.Vulnerabilities === "string"){
        //it is an object and the vulns are in a string
        //return objectOrString.Vulns.replace("-", NON_BREAKING_HYPHEN).split(', ');  //this line seems to be causing an error when hyperlinks are used hypen
        return objectOrString.Vulnerabilities.split(', ');
    } else if (objectOrString &&  typeof objectOrString === "string") {
        //the vulns should be in the string that was passed
        return objectOrString.split(', ');
    }
    else {
        // console.log("No vulnerabilities found in ", objectOrString);
        return [];
    }
};

/**
 * Summary. bbGetValidCustomer
 *
 * Description. gets an array of vulns from an object with a .Vulns paramenter string
 *
 * @param {object}   customersObject           Object or string to parse
 * @param {string}   customerId           Object or string to parse
 * @param {string}   customerInView           Object or string to parse
 *
 * @returns {object} A customer object
 *
 * @example
 /*

 */
// export const bbGetValidCustomer = (customersObject, customerId, customerInView = null) => {
//     if (objectOrString && objectOrString.Vulnerabilities  && typeof objectOrString.Vulnerabilities === "string"){
//         //it is an object and the vulns are in a string
//         //return objectOrString.Vulns.replace("-", NON_BREAKING_HYPHEN).split(', ');  //this line seems to be causing an error when hyperlinks are used hypen
//         return objectOrString.Vulnerabilities.split(', ');
//     } else if (objectOrString &&  typeof objectOrString === "string") {
//         //the vulns should be in the string that was passed
//         return objectOrString.split(', ');
//     }
//     else {
//         console.log("No vulnerabilities found in ", objectOrString);
//         return [];
//     }
// };

export function isNetworkError(err) {
    return !!err.isAxiosError && !err.response;
}

/**
 * Summary. bbStandardRequestHandler
 *
 * Description. gets an array of vulns from an object with a .Vulns paramenter string
 *
 * @param {object}      requestObject              a request object from calling an axios async function
 * @param {string}      nameOfAction         name of the action being used, for user and error messages
 * @param {boolean}        showUserMessages      Whether to show notifications to the user
 * @param {boolean}        showConsoleLogs      Whether to print the console logs
 * @param {boolean}        persistSuccessMessage      If true, any success messages will stick until dismissed by user.
 * *
 * @returns {boolean}      True if the request succeeded, false if not
 *
 * @example
 /*

 */
export const bbStandardRequestHandler = (requestObject, nameOfAction, showUserMessages = false, showConsoleLogs = false, persistSuccessMessage = false) => {
    if (requestObject) {
        //destructure the request
        const {
            statusText,
            status,
            data,
            config,
            request,
            response,
            isAxiosError,
            code
        } = requestObject;

        if(showConsoleLogs) {
            console.info(`${nameOfAction} request: response.`, requestObject, typeof(requestObject), "keys for request object: ", Object.keys(requestObject));
            console.info(requestObject);
            console.info("request.statusText", statusText);//error: undefined | success: all caps code, like CREATED
            console.info("request.status", status);//error: undefined | success: code as a number
            console.info("request.data", data); //error: undefined | success: response in an object (e.g. access .message)
            console.info("request.config", config); //error: object with original request | success: same as error
            console.info("request.request", request); //error: object with .status, .response (with raw json) | success: same as error
            console.info("request.response", response); //error: object with .data as an object (e.g. access .message), .status, and .config with request | success: undefined
            console.info("Is Axios error?", isAxiosError); //error: true | success: undefined
            console.info("request.code", code); //error: object with .data as an object (e.g. access .message), .status, and .config with request | success: undefined
            /*  jfd*******************************
             *   Conclusion:
             *      - check for status code using request.request.status
             *      - if error, message will be in request.response.data.[name of the message key]
             *      - if success, message will be in request.data.[name of the message key]
             *      - have asked john to put all messages in the userMessage key.
                 ********************************** */
        }

        if (isNetworkError(requestObject)) {  //jfd: a code of 0 is probably an ERR_NAME_NOT_RESOLVED so most everything will be null.
            /*  jfd*******************************
             *   First: check for internet connection.
                 ********************************** */
            console.error(`${nameOfAction} isNetworkError error. (No internet connection or server unreachable?)`);
            if(showConsoleLogs) {
                console.error( requestObject, "response data:  ", requestObject);
            }
            // if(showUserMessages) {
            showBBNotification(
                DANGER,
                <IntlMessages id={`general.error.network`}/>,
                <IntlMessages id={`general.error.network.detail`}/>,
                true
            );
            // }
            return false;
        } else if (code === 'ECONNABORTED') {  //jfd: response is a timeout
            /*  jfd*******************************
             *   Then for special case if it was a timeout
                 ********************************** */
            console.error(`${nameOfAction} timeout error.`);
            if(showConsoleLogs) {
                console.error(requestObject, "response data:  ", requestObject);
            }

            // if(showUserMessages) {
            showBBNotification(
                DANGER,
                <IntlMessages id={`general.error.network`}/>,
                <IntlMessages id={`general.error.network.timeout`}/>,
                true
            );
            // }
            return false;
        } else if (status >= 200 && status < 300) {  //jfd: response is a success code
            /*  jfd*******************************
             *   Then for a success case
                 ********************************** */
            console.log(`%c${nameOfAction} request successful.`, "color:green;");
            if(showUserMessages) {
                showBBNotification(
                    SUCCESS,
                    <IntlMessages id={`${nameOfAction}.success`}/>,
                    data && data.userMessage ? data.userMessage : data && data.message ? data.message : <IntlMessages id={`${nameOfAction}.success.detail`}/>,
                    persistSuccessMessage
                );

            }
            return true;

        } else { //jfd: some other error occurred
            /*  jfd*******************************
             *   Anything else is an error where the details should be clearly in the requestObject's data
                 ********************************** */
            console.error(`${nameOfAction} error.`, requestObject, "response data:  ", requestObject);
            if(showUserMessages && response && response.data) {
                showBBNotification(
                    DANGER,
                    <IntlMessages id={`${nameOfAction}.error`}/>,
                    //TODO: safely open response
                    response.data.message
                        ? response.data.message
                            : response.data.userMessage
                            ? response.data.userMessage
                            : response.data.responseText
                                ? response.data.responseText
                                : response.data.description
                                    ? response.data.description
                                    : response.data.error
                                        ? response.data.error
                                        : <IntlMessages id={`${nameOfAction}.error.detail`}/>,
                    true
                );
            } else{
                console.warn("bbStandardRequestHandle, returning an unknown error. showUserMessages is", showUserMessages, "response is", response)
                return false;
            }
            return false;
        }
    } else {
        return false
    }
}

/**
 * Summary. bbShortenString
 *
 * Description. shortens the string and optionally adds dots at the end if its too long.
 *
 * @param {string}      string              a request object from calling an axios async function
 * @param {number}        maxChars      Max Characters
 * @param {boolean}         addDots         Adds stuff at the end if the string is long
 * @param {string}      customSuffix              a custom suffix instead of dots
 * @param {null}      customSuffix              If no custom suffix
 * *
 * @returns {string}      The new string
 *
 * @example
 /*

 */
export const bbShortenString = (string, maxChars = 144, addDots = false, customSuffix= null) => {
    if (typeof(string) !== "string") {
        return string;
    }

    const length = string.length;
    const shortenedString = string.substring(0, maxChars);
    const wasTooLong = (length > maxChars) ? true : false;

    const suffix = wasTooLong ? customSuffix ? customSuffix : addDots ? "..." : "" : "";

    return `${shortenedString}${suffix}`;
}

/**
 * Summary. bbShortenString
 *
 * Description. Takes
 *
 * @param {array}      vulnsArray              array of CVEs from bbGetArrayOfVulnsFromObjectOrString
 * @param {string}      reactKey              salt to add to the children that will be created, in addition to the vuln
 * *
 * @returns {string}      The new string with hyperlinks to Mitre
 *
 * @example
 /*

 */
export const bbStringOfHyperlinkedVulnsFromArray = (vulnsArray, reactKey= null) => {

        const vulnsHTMLWithHyperlinks = vulnsArray.map((vuln) => (
            <BBExternalLink key={`vulnlink_${vuln}_${reactKey}`} tipText={`External Link: Read about ${vuln} at the NIST National Vulnerability Database.`} href={`https://nvd.nist.gov/vuln/detail/${vuln}`}>{vuln}</BBExternalLink>
        ));

        return vulnsHTMLWithHyperlinks.length < 1 ? null : vulnsHTMLWithHyperlinks.reduce((prev, curr) => [prev, ', ', curr]);

}

export const bbActualStringOfHyperlinkedVulnsFromArray = (vulnsArray) => {

    const vulnsHTMLWithHyperlinks = vulnsArray.map((vuln) => (
        // `<a href='https://nvd.nist.gov/vuln/detail/${vuln}'>${vuln}</a>`
        `https://nvd.nist.gov/vuln/detail/${vuln}`
    ));

    return vulnsHTMLWithHyperlinks.length < 1 ? null : vulnsHTMLWithHyperlinks.reduce((prev, curr) => [prev, ', ', curr]);

}

export const bbStringOfVulnsFromTarget = (vulnerableTarget) => {
    if (vulnerableTarget.Vulnerabilities) {
        const vulnsArray = bbGetArrayOfVulnsFromObjectOrString(vulnerableTarget.Vulnerabilities);
        const vulnsHTMLWithHyperlinks = bbStringOfHyperlinkedVulnsFromArray(vulnsArray, vulnerableTarget.IpAddress);

        return vulnsHTMLWithHyperlinks;
    } else {
        console.warn("The given target had no vulnerabilities", vulnerableTarget);
        return null;
    }
}

export const bbActualStringOfVulnsFromTarget = (vulnerableTarget) => {
    if (vulnerableTarget.Vulnerabilities) {
        const vulnsArray = bbGetArrayOfVulnsFromObjectOrString(vulnerableTarget.Vulnerabilities);
        const vulnsHTMLWithHyperlinks = bbActualStringOfHyperlinkedVulnsFromArray(vulnsArray);

        return vulnsHTMLWithHyperlinks;
    } else {
        console.warn("The given target had no vulnerabilities", vulnerableTarget);
        return null;
    }
}

/**
 * Summary. bbIsVectorActive
 *
 * Description. takes a vector object and returns whether the vector can be classified as "active" or not
 *
 * @param {object}      vectorObject              a vector object
 * *
 * @returns {boolean}      true if the vector is active
 *
 * @example
 /*

 */
// export const bbIsVectorActive = (vectorObject) => {
//     // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
//     if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
//         //based of John's way of setting the status codes.
//         switch(vectorObject.Status.Id) {
//             case 0:
//             case 1:
//             case 2:
//             case 4:
//             case 5:
//             case 8:
//                 return true
//             case 3:
//             case 6:
//             case 7:
//             case 9:
//                 return false
//             default:
//                 return null //an invalid Id should not return an answer.
//         }
//     } else {
//         //appears to not be a valid vector object.
//         return null;
//     }
// }

/**
 * Summary. bbIsVectorPotentiallyBreaching
 *
 * Description. Could the vector still theoretically cause a breach
 *
 * @param {object}      vectorObject              a vector object
 * *
 * @returns {boolean}      true if the vector could still breach
 *
 * @example
 /*

 */
export const bbIsVectorPotentiallyBreaching = (vectorObject) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
        //based of John's way of setting the status codes.
        switch(vectorObject.Status.Id) {
            case 0:
            case 1:
            case 2:
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
                return true
            case 3:
            case 6:
                return false
            default:
                return null //an invalid Id should not return an answer.
        }
    } else {
        //appears to not be a valid vector object.
        return null;
    }
}

/**
 * Summary. bbIsVectorViable
 *
 * Description. Viable Vectors have been analyzed and are hopeful (more likely) to breach
 *
 * @param {object}      vectorObject              a vector object
 * *
 * @returns {boolean}      true if the vector could still breach
 *
 * @example
 /*

 */
// export const bbIsVectorViable = (vectorObject) => {
//     // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
//     if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
//         //based of John's way of setting the status codes.
//         switch(vectorObject.Status.Id) {
//             case 2:
//             case 4:
//             case 5:
//                 return true
//             case 0:
//             case 1:
//             case 8:
//             case 7:
//             case 9:
//             case 3:
//             case 6:
//                 return false
//             default:
//                 return null //an invalid Id should not return an answer.
//         }
//     } else {
//         //appears to not be a valid vector object.
//         return null;
//     }
// }

/**
 * Summary. bbTranslateVectorStatusToLikelihood
 *
 * Description. on a scale of 0 - 2 how likely is the vector to cause a breach
 *
 * @param {object}      vectorObject              a vector object
 * *
 * @returns {number}      0, 1, 2
 *
 * @example
 /*

 */
export const bbTranslateVectorStatusToLikelihood = (vectorObject) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
        //based of John's way of setting the status codes.
        switch(vectorObject.Status.Id) {
            case 3:
            case 6:
                return 1
            case 0:
            case 1:
            case 7:
            case 9:
                return 2
            case 2:
            case 4:
            case 5:
            case 8:
                return 3

            default:
                return null; //an invalid Id should not return an answer.
        }
    } else {
        //appears to not be a valid vector object.
        return null;
    }
}

/**
 * Summary. bbGetLikelihoodStringFrom
 *
 * Description. takes a vector and returns a string describing the Vector's risk
 *
 * @param {object}      vectorOrNumber              a vector object
 * @param {number}      vectorOrNumber              0, 1, or 2
 * *
 * @returns {object}      a badge object
 *
 * @example
 /*

 */
export const bbGetLikelihoodBadgeFrom = (vectorOrNumber) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    const badgeHigh = <Badge color="bb-risk-high"><IntlMessages id={"risk.rating.3.title"}/></Badge>
    const badgeMedium = <Badge color="bb-risk-medium"><IntlMessages id={"risk.rating.2.title"}/></Badge>
    const badgeLow = <Badge color="bb-risk-low"><IntlMessages id={"risk.rating.1.title"}/></Badge>
    if(vectorOrNumber.hasOwnProperty("Status") && vectorOrNumber.Status.hasOwnProperty("Id")) {
        //based of John's way of setting the status codes.
        const likelihoodValue = bbTranslateVectorStatusToLikelihood(vectorOrNumber);
        switch(likelihoodValue) {
            case 1:
                return badgeLow
            case 2:
                return badgeMedium
            case 3:
                return badgeHigh
            default:
                return null; //an invalid Id should not return an answer.
        }
    } else if (vectorOrNumber >=0 && vectorOrNumber <= 2) {
        switch(vectorOrNumber) {
            case 1:
                return badgeLow
            case 2:
                return badgeMedium
            case 3:
                return badgeHigh
            default:
                return null; //an invalid Id should not return an answer.
        }
    } else {
        return null;
    }
}

/**
 * Summary. bbIsVectorPotentiallyBreaching
 *
 * Description. Could the vector still theoretically cause a breach
 *
 * @param {object}      vectorObject              a vector object
 * @param {number}      desiredScore              0, 1, 2 -> the desired likelihood score
 * *
 * @returns {boolean}      true if the vector could still breach
 *
 * @example
 /*

 */
export const bbIsVectorRisk = (vectorObject, desiredScore) => {
    if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
        const likelihoodScore = bbTranslateVectorStatusToLikelihood(vectorObject);
        return likelihoodScore === desiredScore;
    } else {
        //appears to not be a valid vector object.
        return null;
    }
}

/**
 * Summary. bbIsCampaignActive
 *
 * Description. takes a vector object and returns whether the vector can be classified as "active" or not
 *
 * @param {object}      campaignObject              a campaign object
 * *
 * @returns {boolean}      true if the campaign is active
 *
 * @example
 /*

 */
export const bbIsCampaignActive = (campaignObject) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    if(campaignObject.hasOwnProperty("Status") && campaignObject.Status.hasOwnProperty("Id")) {
        //based of John's way of setting the status codes.
        switch(campaignObject.Status.Id) {
            case 0:
            case 1:
            case 2:
                return true
            case 3:
                return false
            default:
                return null //an invalid Id should not return an answer.
        }
    } else {
        //appears to not be a valid vector object.
        return null;
    }
}

/**
 * Summary. bbIsCampaignActive
 *
 * Description. takes a vector object and returns whether the vector can be classified as potentially breaching
 *
 * @param {object}      campaignObject              a campaign object
 * *
 * @returns {boolean}      true if the campaign is active
 *
 * @example
 /*

 */
export const bbIsCampaignPotentiallyBreaching = (campaignObject) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    return bbIsCampaignActive(campaignObject);
}

/**
 * Summary. bbIsCampaignActive
 *
 * Description. takes a vector object and returns whether the vector can be classified as viable (likely to cause a breach)
 *
 * @param {object}      campaignObject              a campaign object
 * *
 * @returns {boolean}      true if the campaign is active
 *
 * @example
 /*

 */
export const bbIsCampaignViable = (campaignObject) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    return bbIsCampaignActive(campaignObject);
}

/**
 * Summary. bbGetVectorSimpleStatus
 *
 * Description. takes a vector object and returns a simple status code.  0 = Identify, 1 = Recon, 2 = Attack, 3 = Breach. Null means can't translate.
 *
 * @param {number}      vectorStatusCode              a vector object
 * *
 * @returns {number}      value of status
 *
 * @example
 /*

 */
export const bbGetVectorSimpleStatus = (vectorStatusCode) => {
    // if(vectorObject.hasOwnProperty("Status") && vectorObject.Status.hasOwnProperty("Id")) {
    if (vectorStatusCode) {   //based of John's way of setting the status codes.
        switch(vectorStatusCode) {
            /*  jfd******* codes as of 21 Dec 2020 ************************
            * Vector codes
             * 0 AiPT has identified this as a potential attack vector.
             * 1 This attack vector has been approved for attacks by BreachBits Staff.
             * 2 This attack vector has been deemed viable after analyzing the results of prerequisite scans.
             * 3 This attack vector has been determined to not be viable after analyzing prerequisite scan results.
             * 4 This attack vector has been deemed viable, and attacks against it are ongoing.
             * 5 This attack vector has been successfully exploited by AiPT.
             * 6 Attacks against this attack vector have been exhausted, and exploitation could not be achieved.
             * 7 Attacks against this attack vector have been stopped by BreachBits Staff or Customer.
             * 8 An error has been encountered executing an attack against this vector.  Investigate to determine if a fix is possible before proceeding.
             * 9 Use of this attack vector was denied by BreachBits Staff.
             *
             * Simple Status codes:
             * 0 Identify
             * 1 Recon
             * 2 Attack
             * 3 Breach
            ********************************** */

            case 0:
                return 0
            case 2:
            case 3:
            case 9:
                return 1
            case 1: //when approved for attacks, we are in the attack phase
            case 4:
            case 8:
            case 6: //TODO: awaiting confirmation
            case 7: //TODO: awaiting confirmation
                return 2
            case 5:
                return 3
            default:
                return null //an invalid Id should not return an answer.
        }
    } else {
        //appears to not be a valid vector object.
        return null;
    }
}

/**
 * Summary. bbGetCampaignSimpleStatus
 *
 * Description. takes a vector object and returns a simple status code.  0 = Identify, 1 = Recon, 2 = Attack, 3 = Breach. Null means can't translate.
 *
 * @param {number}      campaignStatusCode              a campaign object
 * *
 * @returns {number}      value of status
 *
 * @example
 /*

 */
export const bbGetCampaignSimpleStatus = (campaignStatusCode) => {
    // if(campaignObject.hasOwnProperty("Status") && campaignObject.Status.hasOwnProperty("Id")) {
    if (campaignStatusCode){    //based of John's way of setting the status codes.
        switch(campaignStatusCode) {
            /*  jfd******* codes as of 21 Dec 2020 ************************
            * Vector codes
             * 0 Requested AiPT has chosen targets and requested approval for the campaign to begin.
             * 1 Approved The campaign has been approved to begin by BreachBits Staff.
             * 2 Ongoing The campaign is currently in-progress.
             * 3 Completed The campaign has completed.
             *
             * Simple Status codes:
             * 0 Plan
             * 1 Approve
             * 2 Execute
             * 3 Complete
            ********************************** */

            case 0:
                return 0
            case 1:
                return 1
            case 2:
                return 2
            case 3:
                return 3
            default:
                return null //an invalid Id should not return an answer.
        }
    } else {
        //appears to not be a valid campaign object.
        return null;
    }
}

/**
 * Summary. bbAppendRowPlaceholdersToTableDataArray
 *
 * Description. takes a vector object and returns a simple status code.  0 = Identify, 1 = Recon, 2 = Attack, 3 = Breach. Null means can't translate.
 *
 * @param {array}      dataArray              array of filled data objects from the db
 * @param {number}      totalNumTargets              total number of targets in the database
 * @param {number}      batchSize              number of records sent back with each response
 * @param {function}      fetchFunction              callback function to dispatch a datacall to API to fetch the ghost row that takes a page number
 * *
 * @returns {array}      array of the filled data with ghosts
 *
 * @example
 /*

 */
export const bbAppendRowPlaceholdersToTableDataArray = (dataArray, totalNumTargets, batchSize, fetchFunction) => {
    // Page  1           2-startWritingPage      4          5            6
    //  [__________][__________][__________][__________][__________][__________]
    //   batchSize ^    ^ ^----^frontRemain                   ^totalNumTargets
    // dataArray.length-|                    |
    //                  |------ sizeOfGhostArray -------------|

    if(totalNumTargets && dataArray.length < totalNumTargets){
        //the data array only contains a subset of the data.

        // const batchSize = 10; //how many records does each /page call return
        const sizeOfGhostArray = (totalNumTargets - dataArray.length) <= (batchSize) ? totalNumTargets - dataArray.length : (batchSize);
        const frontRemain = dataArray.length % batchSize;
        const startWritingPage = Math.ceil(dataArray.length/batchSize); //The first page that the ghosts should write on (aka fetch on)

        //create a ghost array
        const ghostArray = new Array(sizeOfGhostArray);
        ghostArray.fill({});

        // console.log(`"Creating ghost array for a data set of ${totalNumTargets} based on present data size of ${dataArray.length} with batchSize ${batchSize}, sizeOfGhostArray ${sizeOfGhostArray}, frontRemain ${frontRemain}, startWritingPage ${startWritingPage}.`)

        //step through each position and add the object
        for (let i in ghostArray){
            //for the frontRemain subsection
            if(i < frontRemain) {
                //they need to fetch the startWritingPage
                const ghostId = dataArray.length + Number.parseInt(i);
                // console.log(ghostId, " (startWritingPage) now writing on page", startWritingPage)
                ghostArray[i] = {
                    "ghost" : true,
                    "id" : ghostId,
                    "fetchFunction" : fetchFunction,
                    "fetchPage" : startWritingPage
                }
            } else {
                //others need to fetch the startWritingPage
                const thisWritePage = startWritingPage + Math.floor((i - frontRemain) / batchSize) + 1;
                const ghostId = dataArray.length + Number.parseInt(i);
                // console.log(ghostId, " (thisWritePage) now writing on page", thisWritePage)
                ghostArray[i] = {
                    "ghost" : true,
                    "id" : ghostId,
                    "fetchFunction" : fetchFunction,
                    "fetchPage" : thisWritePage
                }
            }
        }

        // console.log("Built this ghost Array, ", ghostArray);
        return [...dataArray, ...ghostArray];

    } else {
        return dataArray
    }
}

/**
 * Summary. bbScopeIcon
 *
 * Description. Creates a on-brand scope image
 *
 * @param {boolean}      isOOS              true if wanting symbol for "in scope", otherwise will return out of scope
 *  @param {string}      isOOS              true if wanting symbol for "in scope", otherwise will return out of scope
 * @param {number}      size              pixel font size of the element
 * @param {boolean}      noColor              whether color should be dictated
 * * *
 * @returns {JSX.Element}      Element
 *
 * @example
 /*

 */
export const bbScopeIcon = (isOOS, size = 20, noColor = false) => {
    return ((isOOS && isOOS !== "0") || isOOS === "1")
        ? <Tooltip title={"Out of Scope (OOS).  Out of Scope elements will not be actively attacked and may therefore be more vulnerable than elements that are In Scope."}>
            <GpsOffSharpIcon className={noColor ? "" : "text-danger"} style={{fontSize: size}}/>
        </Tooltip>
        :<Tooltip title={"In Scope.  Elements in scope are subject to active attack and breach activities."}>
            <GpsFixedSharpIcon className={noColor ? "" : "text-primary"} style={{fontSize: size}}/>
        </Tooltip>
}

/**
 * Summary. bbTranslateRiskToColor
 *
 * Description. give it a risk rating it will return css color string
 *
 * @param {number}      risk              one of the 5 risk score integers, 0 - 4. 0 is lowest risk.
 * * *
 * @returns {string}      css color string
 *
 * @example
 /*

 */
export const bbTranslateRiskToColor = (risk) => {
    if (risk >= 0 && risk <=4 ){
        if (risk === 0) {
            return "bb-risk-lowest"
        } else if (risk === 1) {
            return "bb-risk-low"
        } else if (risk === 2) {
            return "bb-risk-medium"
        } else if (risk === 3) {
            return "bb-risk-high"
        } else if (risk === 4) {
            return "bb-risk-highest"
        } else {
            return ""
        }
    } else {
        return ""
    }
}

/**
 * Summary. bbTranslateBreachRiskScoreToColor
 *
 * Description. Get the css color name of the given BreachRisk™ score
 *
 * @param {number}      riskScore              a BreachRisk score between 0.0 - 10.0.
 * @param {boolean}      returnHex              Default is false, if true, will return a hex string instead of a scss variable string
 * * *
 * @returns {string}      name of the Risk score category from Lowest - Highest
 *
 * @example
 /*

 */
export const bbTranslateBreachRiskScoreToColor = (riskScore, returnHex = false) => {
    const parsedScore = parseFloat(riskScore, 1);
    if (parsedScore >= 0.0 && parsedScore <=10.0 ){
        const riskCategory = bbTranslateBreachRiskScoreToCategory(parsedScore);
        switch (riskCategory) {
            case "Lowest":
                return returnHex ? "#00863B" : "bb-risk-lowest"
            case "Low":
                return returnHex ? "#5FBA15" :"bb-risk-low"
            case "Medium":
                return returnHex ? "#F2E205" :"bb-risk-medium"
            case "High":
                return returnHex ? "#F28705" :"bb-risk-high"
            case "Highest":
                return returnHex ? "#D93D04" :"bb-risk-highest"
            default: return ""
        }
    } else {
        return ""
    }
}

/**
 * Summary. bbTranslateBreachRiskScoreToCategory
 *
 * Description. Get the category name of the given BreachRisk score
 *
 * @param {number}      riskScore              a BreachRisk score between 0.0 - 10.0.
 * * *
 * @returns {string}      name of the Risk score category from Lowest - Highest
 *
 * @example
 /*

 */
export const  bbTranslateBreachRiskScoreToCategory = (riskScore) => {
    const parsedScore = parseFloat(riskScore, 1);
    if (parsedScore >= 0.0 && parsedScore <=10.0 ){
        if (parsedScore >= 0 && parsedScore <2.0) {
            return "Lowest"
        } else if (parsedScore >= 2.0 && parsedScore <4.0) {
            return "Low"
        } else if (parsedScore >= 4.0 && parsedScore <6.0) {
            return "Medium"
        } else if (parsedScore >= 6.0 && parsedScore <8.0) {
            return "High"
        } else if (parsedScore >= 8.0 && parsedScore <=10.0) {
            return "Highest"
        } else {
            return ""
        }
    } else {
        return ""
    }
}

/**
 * Summary. bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor
 *
 * Description. Takes the high and low confidence scores and returns a subjective category description
 *
 * @param {number}      confidenceLow              a BreachRisk score lower limit between 0.0 - 10.0.
 * @param {number}      confidenceHigh              a BreachRisk score upper limit between 0.0 - 10.0.
 * * *
 * @returns {string}      name of the Risk score category from Lowest - Highest
 *
 * @example
 /*

 */
const  bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor = (confidenceLow, confidenceHigh) => {
    const parsedLow = parseFloat(confidenceLow).toFixed(1) ;
    const parsedHigh = parseFloat(confidenceHigh).toFixed(1) ;
    const delta = parsedHigh - parsedLow;
    if (delta >= 0.0 && delta <=10.0 ){
        if (delta <= 0.5) {
            return "bb-risk-lowest"
        } else if (delta <= 1) {
            return "bb-risk-low"
        } else if (delta <= 2.0) {
            return "bb-risk-medium"
        } else if (delta <= 4.0) {
            return "bb-risk-high"
        } else if (delta > 4.0) {
            return "bb-risk-highest"
        } else {
            return ""
        }
    } else if (isNaN(delta)) {
        return ""
    } else {
        console.warn("Fidelity Score out of range using confidenceLow", confidenceLow, "confidenceHigh", confidenceHigh, "delta", delta);
        return ""
    }
}

/**
 * Summary. bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory
 *
 * Description. Takes the high and low confidence scores and returns a subjective category description
 *
 * @param {number}      confidenceLow              a BreachRisk score lower limit between 0.0 - 10.0.
 * @param {number}      confidenceHigh              a BreachRisk score upper limit between 0.0 - 10.0.
 * * *
 * @returns {string}      css color string of the Risk score category from Lowest - Highest
 *
 * @example
 /*

 */
const  bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory = (confidenceLow, confidenceHigh) => {
    const parsedLow = parseFloat(confidenceLow).toFixed(1) ;
    const parsedHigh = parseFloat(confidenceHigh).toFixed(1) ;
    const delta = parsedHigh - parsedLow;
    if (delta >= 0.0 && delta <=10.0 ){
        if (delta <= 0.5) {
            return "Very High Fidelity"
        } else if (delta <= 1) {
            return "High Fidelity"
        } else if (delta <= 2.0) {
            return "Moderate Fidelity"
        } else if (delta <= 4.0) {
            return "Low Fidelity"
        } else if (delta > 4.0) {
            return "Very Low Fidelity"
        } else {
            return ""
        }
    } else {
        return ""
    }
}


/**
 * Summary. bbGetDisplayNameFromAPIFidelityCategoryId
 *
 * Description. Returns the display name suitable for dashboard from a fidelity object
 *
 * @param {object}      fidelityObject              A fidelity object from the API
 * @param {boolean}      useCustomString              If true, will use the customer labels.
 * * *
 * @returns {string}      String from API
 *
 * @example
 /*

 */
export const  bbGetDisplayNameFromAPIFidelity = (fidelityObject, useCustomString = false) => {
    // console.log("Attempting to get fidelity display name from ", fidelityObject);
    if (bbIsObject(fidelityObject)) {
        try {
            if (useCustomString) {
                switch (fidelityObject.id) {
                    case 0:
                        return "Very Low Fidelity"
                    case 1:
                        return "Low Fidelity"
                    case 2:
                        return "Medium Fidelity"
                    case 3:
                        return "High Fidelity"
                    case 4:
                        return "Very High Fidelity"
                    default:
                        console.warn("No Fidelity Id case found in fidelityObject:", fidelityObject);
                        return null
                }
            } else {
                return fidelityObject.name;
            }
        } catch (e) {
            console.warn(e);
            return null;
        }

    } else {
        console.warn("No Fidelity Id case found in fidelityObject:", fidelityObject);
        return null
    }
}

/**
 * Summary. bbGetColorFromAPIFidelityCategoryId
 *
 * Description. Takes the API fidelity category and returns a color string
 *
 *  @param {object}      fidelityObject              A fidelity object from the API
 * * *
 * @returns {string}      CSS color string
 *
 * @example
 /*

 */
export const  bbGetColorFromAPIFidelity = (fidelityObject) => {
    if (bbIsObject(fidelityObject)) {
        try {

                switch (fidelityObject.id) {
                    case 0:
                        return "bb-risk-highest"
                    case 1:
                        return "bb-risk-high"
                    case 2:
                        return "bb-risk-medium"
                    case 3:
                        return  "bb-risk-low"
                    case 4:
                        return  "bb-risk-lowest"
                    default:
                        console.warn("No Fidelity Id case found in fidelityObject:", fidelityObject);
                        return null
                }
        } catch (e) {
            console.warn(e);
            return null;
        }

    } else {
        console.warn("No Fidelity Id case found in fidelityObject:", fidelityObject);
        return null
    }
}

export const bbErrorSection = (fontSize = "30px") => {
    return <div className={"animated fadeIn animation-duration-20"}>
        <Tooltip title={"There was a problem loading this data.  Please try again later."}>
            <span>
            <BBIconLoadError style={{fontSize:fontSize}}/>
                </span>
        </Tooltip>
    </div>
}

export const bbConstructionCone = () => {
    return <Tooltip title={"Under Construction"}>
        <span>
        <BBIconConstructionCone className={"text-warning"} style={{fontSize:"0.98em", margin: 5, padding: 1, marginTop: "-0.33em", marginBottom: 0}}/>
        </span>
    </Tooltip>
}

/**
 * Summary. bbRiskDirectionArrow
 *
 * Description. gives a tool-tipped directional risk arrow
 *
 * @param {number}      direction              one of the 5 risk score integers, 0 - 4. 0 is lowest risk.
 *  @param {string}      direction              "unknown"
 * * *
 * @returns {JSX.Element}      Tooltip with a colored directional icon
 *
 * @example
 /*

 */
export const bbRiskDirectionArrow = (direction) => {
    if (direction || direction === 0) {
        let icon = null
        let tipRiskText = null
        switch(direction) {
            case 4:
                icon = <BBIconRiskDirectionUp className={"text-bb-risk-highest"} />
                tipRiskText = "significantly increases"
                break;
            case 3:
                icon = <BBIconRiskDirectionUpHalf className={"text-bb-risk-high"} />
                tipRiskText = "somewhat increases"
                break;
            case 2:
                icon = <BBIconRiskDirectionRight className={"text-bb-risk-medium"} />
                tipRiskText = "neither increases nor reduces"
                break;
            case 1:
                icon = <BBIconRiskDirectionDownHalf className={"text-bb-risk-low"} />
                tipRiskText = "somewhat reduces"
                break;
            case 0:
                icon = <BBIconRiskDirectionDown className={"text-bb-risk-lowest"} />
                tipRiskText = "significantly reduces"
                break;
            case "unknown":
                icon = <BBIconRiskDirectionUpAndDown className={"text-gray"} />
                tipRiskText = "may or may not impact"
                break;
            default:
                break;
        }
        if (icon && tipRiskText) {
            const startText = "This "
            const endText = " one or more elements of your cybersecurity risk."
            return <span style={{margin: 3}}>
                <Tooltip title={`${startText}${tipRiskText}${endText}`}>
                <span>
                    {icon}
                </span>
            </Tooltip>
            </span>
        } else {
            return null
        }
    } else {
        return null
    }
}

/**
 * Summary. bbGetArrayOfBreachAttackIdsFrom
 *
 * Description. returns an array of attack IDs for breaches from vector objects
 *
 * @param {object}      vectors              an object of vector objects
 * @param {boolean}      past              true if you want past breaches
 * @param {boolean}      current              true if you want current breaches
 * * *
 * @returns {array}      Array of attack IDs
 *
 * @example
 /*

 */
export const bbGetArrayOfBreachAttackIdsFromVectors = (vectors, past = false, current = false) => {
    // console.log("bbGetArrayOfBreachAttackIdsFromVectors with vectors", vectors)
    if (vectors && (past || current)){
        try {
            if (Object.keys(vectors).length > 0) {
                let breaches = [];

                // const breachTypeKey = pastBreaches ? "past_breaches" : "current_breaches";

                //go through the vectors
                //go through each vector, and compile an array of all active_breaches
                for(const vector in vectors) {
                    if (vectors.hasOwnProperty(vector)) {
                        const {
                            past_breaches = [],
                            current_breaches = [],
                        } = vectors[vector]["Attack Totals"]

                        if (past) {
                            Array.prototype.push.apply(breaches, past_breaches);
                        }
                        if (current) {
                            Array.prototype.push.apply(breaches, current_breaches);
                        }
                    }
                }
                // console.log("bbGetArrayOfBreachAttackIdsFromVectors returning breaches", breaches);
                return breaches;
            } else {
                return [];
            }
        } catch(e) {
            return null
        }
    } else {
        return null
    }
}

/**
 * Summary. bbGetArrayOfBreachAttackIdsFrom
 *
 * Description. returns an array of attack IDs for breaches from campaigns objects
 *
 * @param {object}      metaCampaigns              the meta campaign data from the store
 * @param {string}      customerIdToUse              Id for the customer you want
 * @param {boolean}      past              true if you want past breaches
 * * @param {boolean}      current              true if you want current breaches
 * * *
 * @returns {array}      Array of attack IDs
 *
 * @example
 /*

 */
export const bbGetArrayOfBreachAttackIdsFromCampaigns = (metaCampaigns, customerIdToUse, past = false, current = false) => {
    // console.log("bbGetArrayOfBreachAttackIdsFromCampaigns with metaCampaigns", metaCampaigns, "customerIdToUse", customerIdToUse);
    if (metaCampaigns && customerIdToUse && (past || current)){
        try {
            if (metaCampaigns.hasOwnProperty(customerIdToUse)) {
                // const breachTypeKey = pastBreaches ? "past_breaches" : "current_breaches";
                let breaches = [];

                const {
                    past_breaches = [],
                    current_breaches = [],
                } = metaCampaigns[customerIdToUse]

                if (past) {
                    Array.prototype.push.apply(breaches, past_breaches);
                }
                if (current) {
                    Array.prototype.push.apply(breaches, current_breaches);
                }
                // console.log("bbGetArrayOfBreachAttackIdsFromCampaigns returning breachesFromData", breachesFromData);
                return breaches;
            } else {
                return [];
            }
        } catch(e) {
            return null
        }
    } else {
        return null
    }
}

/**
 * Summary. bbIsServiceHighRisk
 *
 * Description. filter function looks at a string and if it is a high risk service returns true
 *
 * @param {string}      service              a service string ex: "ssh"
 * *
 * @returns {boolean}      true if the service is high risk historically
 *
 * @example
 /*

 */
export const bbIsServiceHighRisk = (service) => {
    // console.log("bbIsVectorActive inbound vector is ", vectorObject, vectorObject.hasOwnProperty("Status"), vectorObject.Status.hasOwnProperty("Id"))
    if(typeof service ==="string") {
        //based of John's way of setting the status codes.
        const serviceLowercase = service.toLowerCase();
        const dangerousServices = [
            "rdp",
            "ssh",
            "netbios",
            "smb",
            "telnet",
            "ftp"
        ]
        return dangerousServices.includes(serviceLowercase) || serviceLowercase.startsWith('netbios');
    } else {
        //appears to not a valid string
        return null;
    }
}

/**
 * Summary. bbIsBetasOk
 *
 * Description. checks the given authUser and determines if the user is allowed to see betas
 *
 * @param {object}      authUser              an authUser object to be evaluated
 * *
 * @returns {boolean}      true if authUser meets criteria for betas
 *
 * @example
 /*

 */
export const bbIsBetasOk = (authUser) => {
    try {
        if (isCurrentUserMemberOf(authUser, "admin") || (!authUser.customers && !authUser.customers.isEmpty()) || (authUser.customers && authUser.customers.length > 1)) {
            return true
        } else {
            return false
        }
    } catch(e) {
        return false
    }

}

export const bbIsObject = (a) => {
    return (!!a) && (a.constructor === Object);
};

export const bbIsArray = (a) => {
    return (!!a) && (a.constructor === Array);
};

/**
 * Summary. bbIsBetasOk
 *
 * Description. checks the given authUser and determines if the user is allowed to see betas
 *
 * @param {object}      stateData              state of the compliance object
 * @param {string}      forComplianceStandardId              Id of the compliance standard
 * @param {string}      forControlId              Id of the control
 * @param {string}      forSourceId              Id of the source of the assessment. 1 = self assessment, 2 = third party, 3 = breachbits
 * *
 * @returns {boolean}      true if authUser meets criteria for betas
 *
 * @example
 /*

 */
export const bbExtractAssessmentScore = (stateData, forComplianceStandardId, forControlId, forSourceId) => {
    try {
        const assessmentGroup = bbIsObject(stateData) ? bbIsObject(stateData[forComplianceStandardId]) ? bbIsObject(stateData[forComplianceStandardId][forControlId]) ? stateData[forComplianceStandardId][forControlId] : null : null : null;
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
        if(bbIsObject(assessmentGroup)) {
            let sourcedAssessment;
            for (const recordId in assessmentGroup) {
                if(assessmentGroup[recordId].hasOwnProperty("Assessment Source") && assessmentGroup[recordId]["Assessment Source"].Id === forSourceId) {
                    if (!sourcedAssessment) {
                        sourcedAssessment = assessmentGroup[recordId];
                    } else if (sourcedAssessment && bbDangerousStringToDate(sourcedAssessment["Created DateTime"]) < bbDangerousStringToDate(assessmentGroup[recordId]["Created DateTime"]))  {
                        //if there was already a source assessment found, update it if the date is sooner
                        sourcedAssessment = assessmentGroup[recordId];
                    }
                }
            }

            if (sourcedAssessment) {
                // console.log("Found an assessment with source of ", forSourceId, sourcedAssessment["Assessment Status"].Id)
                return sourcedAssessment["Assessment Status"].Id;
            } else {
                return null;
            }
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return false
    }

}

export const bbExtractLastAssessmentDateAndBy = (stateData, forComplianceStandardId, forControlId, forSourceId) => {
    try {
        const assessmentGroup = bbIsObject(stateData) ? bbIsObject(stateData[forComplianceStandardId]) ? bbIsObject(stateData[forComplianceStandardId][forControlId]) ? stateData[forComplianceStandardId][forControlId] : null : null : null;
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
        if(bbIsObject(assessmentGroup)) {
            let sourcedAssessment;
            for (const recordId in assessmentGroup) {
                if(assessmentGroup[recordId].hasOwnProperty("Assessment Source") && assessmentGroup[recordId]["Assessment Source"].Id === forSourceId) {
                    if (!sourcedAssessment) {
                        sourcedAssessment = assessmentGroup[recordId];
                    } else if (sourcedAssessment && bbDangerousStringToDate(sourcedAssessment["Created DateTime"]) < bbDangerousStringToDate(assessmentGroup[recordId]["Created DateTime"]))  {
                        //if there was already a source assessment found, update it if the date is sooner
                        sourcedAssessment = assessmentGroup[recordId];
                    }
                }
            }

            if (sourcedAssessment) {
                // console.log("Found an assessment with source of ", forSourceId, sourcedAssessment["Assessment Status"].Id)
                return {
                    lastAssessedDate: sourcedAssessment["Created DateTime"],
                    lastAssessedBy: sourcedAssessment["Created By"]

                };
            } else {
                return null;
            }
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return false
    }

}

/**
 * Summary. bbDictionaryOfModules
 *
 * Description. A hard coded dictionary of module names, ids, etc until fetch from db
 *
 // * @property {number} key The id of the module (from the db)
 // * @property {number} key.id The id of the module (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} breachboardUrl URL ready to use in a Link element
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfModules = {
    1 : {
        id: 1,
        internalName: "monitor",
        displayName: "Monitor",
        longName: "CIRT Monitor",
        breachboardUrl: "/board/CIRT/external",
        breachboardUserGuideUrl: "/board/userguide/MonitorModule",
        breachboardUserGuideUrlHash: "MonitorSection",
        description: "The Monitor module shows you what attackers can see, but will not test your defenses. Most elements of this module are displayed in the Attack Surface tab of the External Threat section.",
        icon: <BBIconHexModuleMonitor/>
    },
    2 : {
        id: 2,
        internalName: "insider",
        displayName: "Insider Threat",
        longName: "CIRT Insider Threat",
        breachboardUrl: "/board/CIRT/insider",
        breachboardUserGuideUrl: "/board/userguide/InsiderThreatModule",
        breachboardUserGuideUrlHash: "InsiderThreatSection",
        description: "The Insider Threat module allows you to conduct self-directed attacks from within your infrastructure. If you have this module active, you will have access to the Insider Threat section.",
        icon: <BBIconHexModuleInsiderThreat/>
    },
    3 : {
        id: 3,
        internalName: "perimeter",
        displayName: "Perimeter",
        longName: "CIRT Perimeter",
        breachboardUrl: "/board/CIRT/external",
        breachboardUserGuideUrl: "/board/userguide/PerimeterModule",
        breachboardUserGuideUrlHash: "PerimeterSection",
        description: "The Perimeter module identifies all attack vectors and continuously launches attacks against them, allowing you to test your external defenses.",
        icon: <BBIconHexModuleExternalThreat/>
    },
    4 : {
        id: 4,
        internalName: "social",
        displayName: "Social",
        longName: "CIRT Social",
        breachboardUrl: "/board/CIRT/external",
        breachboardUserGuideUrl: "/board/userguide/SocialModule",
        breachboardUserGuideUrlHash: "SocialSection",
        description: "The Social module continuously launches high-quality social attacks with focused phishing campaigns, allowing you to see how effective your defenses are against one of the most potent attack vectors.",
        icon: <BBIconHexModuleSocial/>
    },
    6 : {
        id: 6,
        internalName: "cmmc",
        displayName: "Compliance",
        longName: "Compliance (CMMC)",
        breachboardUrl: "/board/compliance/cmmc",
        breachboardUserGuideUrl: "/board/userguide/ComplianceModule",
        breachboardUserGuideUrlHash: "ComplianceSection",
        description: "The CMMC Compliance module enables the CMMC section where you can access automatically-collected objective evidence to support your CMMC compliance program.",
        icon: <BBIconHexModuleCompliance/>
    },
    7 : {
        id: 7,
        internalName: "nist-171",
        displayName: "Compliance",
        longName: "Compliance (NIST SP 800-171)",
        breachboardUrl: "",
        breachboardUserGuideUrl: "/board/userguide/ComplianceModule",
        breachboardUserGuideUrlHash: "ComplianceSection",
        description: "",
        icon: <BBIconHexModuleCompliance/>
    },
}

/**
 * Summary. bbArrayOfActiveModules
 *
 * Description. checks the given customer and returns an array of all modules
 *
 * @param {object}      customer              a customer object
 * @param {boolean}     activeOnly            wheather to only send back active modules. defaul true
 **
 * @returns {Array}      of ModuleIds
 *
 * @example
 /*

 */
export const bbArrayOfActiveModules = (customer, activeOnly = true) => {
    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
        const arrayOfModuleIds = []
        if(bbIsObject(customer) && customer.hasOwnProperty("Modules")) {
            // console.log("about to look for modules within customer.Modules", customer.Modules)
            for (const moduleId in customer.Modules) {
                // console.log("evaluating key", moduleId, "customer.Modules[moduleId].IsActive", customer.Modules[moduleId].IsActive)
                //if its the full module object
                if (bbIsObject(customer.Modules[moduleId]) && customer.Modules[moduleId].hasOwnProperty("Module")) {
                    if(activeOnly) {
                        if(customer.Modules[moduleId].IsActive){
                            arrayOfModuleIds.push(customer.Modules[moduleId].Module.Id);
                        }
                    } else {
                        arrayOfModuleIds.push(customer.Modules[moduleId].Module.Id);
                    }
                } else {
                    //otherwise, its just a plain array, assume they are active
                    arrayOfModuleIds.push(customer.Modules[moduleId]);
                }

            }

            return arrayOfModuleIds;
        } else {
            console.warn("bbArrayOfActiveModules was called but didn't pass initial checks. bbIsObject(customer) is ", bbIsObject(customer), "customer.hasOwnProperty(\"modules\") is ", customer.hasOwnProperty("modules") );
            return null
        }
    } catch(e) {
        return null
    }

}

/**
 * Summary. bbArrayOfActiveSubscriptions
 *
 * Description. checks the given customer and returns an array of all modules
 *
 * @param {object}      customer              a customer object
 * @param {boolean}     activeOnly            wheather to only send back active modules. defaul true
 * @param {boolean}     sendFullObject            wheather to send the full object. if False, will only send back subscriptiontypeids.
 * @param {number}      forThisSubscriptionTypeIdOnly   If sent, will only return subscriptions with that typeId
 **
 * @returns {Array}      of ModuleIds
 *
 * @example
 /*

 */
export const bbArrayOfActiveSubscriptions = (customer, activeOnly = true, sendFullObject = false, forThisSubscriptionTypeIdOnly = null) => {
    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
        const arrayOfSubscriptionIds = []
        const arrayOfSubscriptionObjects = [];
        if(bbIsObject(customer) && customer.hasOwnProperty("Subscriptions") && isObject(customer.Subscriptions)) {
            // console.group("about to look for subscriptions within customer.Subscriptions", customer.Subscriptions)

            //check to see if should filter out by forThisSubscriptionTypeIdOnly
            let  customerSubscriptions = {}
            if(forThisSubscriptionTypeIdOnly){
                customerSubscriptions = filterObject(customer.Subscriptions, (_, sub) => sub.subscription_type && sub.subscription_type.id && sub.subscription_type.id === forThisSubscriptionTypeIdOnly);
                // console.log("Filtered customer subscriptions to only contain forThisSubscriptionTypeIdOnly of ", forThisSubscriptionTypeIdOnly, "customerSubscriptions", customerSubscriptions);
            } else {
                customerSubscriptions = customer.Subscriptions;
                // console.log("Not filtering customer subscriptions. forThisSubscriptionTypeIdOnly is", forThisSubscriptionTypeIdOnly, "customerSubscriptions", customerSubscriptions);
            }

            for (const subscriptionId in customerSubscriptions) {
                // console.log("evaluating key", subscriptionId)
                //if its the full module object
                if (bbIsObject(customer.Subscriptions[subscriptionId]) && customer.Subscriptions[subscriptionId].hasOwnProperty("subscription_type") && customer.Subscriptions[subscriptionId].hasOwnProperty("subscription_end")) {
                    //check to see if subscription end is before now
                    const now = Date.now();
                    const subscriptionEnd = bbDangerousStringToDate(customer.Subscriptions[subscriptionId].subscription_end);

                    //check if there is no subscription end date (for example, BRP gave them the sub)
                    const isNoSubscriptionEndDate = !customer.Subscriptions[subscriptionId].subscription_end || subscriptionEnd === "" || !bbDangerousStringToDate(customer.Subscriptions[subscriptionId].subscription_end);

                    //check if active
                    const isThisSubscriptionActive = customer.Subscriptions[subscriptionId].is_active

                    // console.log("it is now", now, "and subscription ends", subscriptionEnd, "is_active is", isThisSubscriptionActive, "is now less than expired date", subscriptionEnd > now);

                    //if it is not before now and is active, then add it to the list
                    if(isThisSubscriptionActive && (subscriptionEnd > now || isNoSubscriptionEndDate)) {
                        // console.log("Subscription is active for ", customer.Subscriptions[subscriptionId].subscription_type)

                        arrayOfSubscriptionIds.push(customer.Subscriptions[subscriptionId].subscription_type.id);
                        arrayOfSubscriptionObjects.push(customer.Subscriptions[subscriptionId]);
                    }
                }
                // else {
                //     //otherwise, its just a plain array, assume they are active
                //     arrayOfModuleIds.push(customer.Modules[moduleId]);
                // }

            }
            // console.groupEnd();

            if(sendFullObject) {
                return arrayOfSubscriptionObjects;
            } else {
                return arrayOfSubscriptionIds;
            }

        } else {
            console.warn("bbArrayOfActiveSubscriptions was called but didn't pass initial checks. bbIsObject(customer) is ", bbIsObject(customer), "bbIsObject(customer.Subscriptions) is ", bbIsObject(customer.Subscriptions), "customer.hasOwnProperty(\"Subscriptions\") is ", customer.hasOwnProperty("Subscriptions") );
            return null
        }
    } catch(e) {
        return null
    }

}

/**
 * Summary. bbDoesCustomerHaveAccessToModule
 *
 * Description. returns true of the given customer has access to the given module
 *
 * @param {object}      customer              a customer object
 * @param {string, number}     module            id of the module
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbDoesCustomerHaveAccessToModule = (customer, module ) => {
    const moduleId = bbGetModulePropertyFromIdOrName(module, "id");
    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))

        if(bbIsObject(customer) && customer.hasOwnProperty("Modules")) {
            const activeModulearray = bbArrayOfActiveModules(customer);
            // console.log("bbDoesCustomerHaveAccessToModule found these active modules", activeModulearray);
            return activeModulearray.includes(moduleId) || activeModulearray.includes(moduleId.toString());
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return null
    }

}

/**
 * Summary. bbDictionaryOfSubscriptionTypes
 *
 * Description. A hard coded dictionary of subscription names, ids, etc until fetch from db
 *
 // * @property {number} id The id of the sub type (from the db)
 // * @property {number} value A numberical value of the sub type, in cases where db value is a string (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfSubscriptionTypes = {
    1 : {
        id: 1,
        value: 1,
        internalName: "BRP",
        displayName: "BreachRisk™ Portfolio",
        longName: "BreachRisk™ Portfolio",
        description: "",
        icon: null
    },

    2 : {
        id: 2,
        value: 2,
        internalName: "BRfB",
        displayName: "BreachRisk™ for Business",
        longName: "BreachRisk™ for Business",
        description: "",
        icon: null
    },
    3 : {
        id: 3,
        value: 3,
        internalName: "CIRT",
        displayName: "CIRT™",
        longName: "Continuous Intelligent Red Team",
        description: "",
        icon: null
    },

}

/**
 * Summary. bbGetSubscriptionPropertyFromIdOrName
 *
 * Description. returns a string with the display name of the subscription for a given Id
 *
 * @param {string, number}     typeNameOrId            id of the brLevel or the internal name
 * @param {string}     property            the property you want returned. defaults to displayName
 **
 * @returns {string}      name of the brLevel
 *
 * @example
 *   id
 internalName
 displayName
 longName
 breachboardUrl
 description
 icon
 /*

 */
export const bbGetSubscriptionPropertyFromIdOrName = (typeNameOrId, property="displayName") => {
    const allProperties = Object.keys(bbDictionaryOfSubscriptionTypes[1]);
    const foundProperty = allProperties.find(element => element === property);
    if (!foundProperty) {
        console.warn("Looking for subscription property ", property, " but it wasn't found");
        return undefined;
    }

    try {
        if (typeof(typeNameOrId) === "number") {
            return bbDictionaryOfSubscriptionTypes[typeNameOrId][property]
        } else if (typeof(typeNameOrId) === "string") {
            const arrayOfSubscriptions = Object.keys(bbDictionaryOfSubscriptionTypes).map((k) => bbDictionaryOfSubscriptionTypes[k])
            const result = arrayOfSubscriptions.find(({ internalName }) => internalName === typeNameOrId);
            return result[property];
        }

    } catch(e) {
        return null
    }

}

//TODO: Make this work with portfolio by adding portfolio levels
/**
 * Summary. bbDictionaryOfSubscriptionLevels
 *
 * Description. A hard coded dictionary of subscription level names, ids, etc until fetch from db
 *
 // * @property {number} id The id of the sub level level (from the db)
 // * @property {number} value A numberical value of the sub level, in cases where db value is a string (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfSubscriptionLevels = {
    1 : {
        id: 1,
        value: 1,
        sortOrder: 1,
        internalName: "portfolioTrial",
        displayName: "Portfolio Trial",
        longName: "Portfolio Trial",
        description: "BreachRisk Portfolio trial subscription.",
        icon: null
    },
    2 : {
        id: 2,
        value: 2,
        sortOrder: 2,
        internalName: "portfolioStarter",
        displayName: "Portfolio Starter",
        longName: "Portfolio Starter",
        description: "BreachRisk Portfolio starter subscription.",
        icon: null
    },
    3 : {
        id: 3,
        value: 3,
        sortOrder: 3,
        internalName: "portfolioPro",
        displayName: "Portfolio Pro",
        longName: "Portfolio Pro",
        description: "BreachRisk Portfolio Pro subscription.",
        icon: null
    },
    4 : {
        id: 4,
        value: 4,
        sortOrder: 4,
        internalName: "portfolioPremium",
        displayName: "Portfolio Premium",
        longName: "Portfolio Premium",
        description: "BreachRisk Portfolio premium subscription.",
        icon: null
    },
    5 : {
        id: 5,
        value: 5,
        sortOrder: 2,
        internalName: "trial",
        displayName: "Trial",
        longName: "Trial",
        description: "BreachRisk for Business Trial at the Lite Level",
        icon: null
    },
    6 : {
        id: 6,
        value: 6,
        sortOrder: 2,
        internalName: "lite",
        displayName: "Lite",
        longName: "Lite",
        description: "",
        icon: null
    },
    7 : {
        id: 7,
        value: 7,
        sortOrder: 3,
        internalName: "pro",
        displayName: "Pro",
        longName: "Pro",
        description: "",
        icon: null
    },
    10 : {
        id: 10,
        value: 10,
        sortOrder: 1,
        internalName: "free",
        displayName: "Free",
        longName: "Free",
        description: "",
        icon: null
    },
    11 : {
        id: 11,
        value: 11,
        sortOrder: 4,
        internalName: "premium",
        displayName: "Premium",
        longName: "Premium",
        description: "",
        icon: null
    },
}

/**
 * Summary. bbGetSubscriptionLevelPropertyFromIdOrName
 *
 * Description. returns a string with the display name of the subscription for a given Id
 *
 * @param {string, number}     levelNameOrId            id of the brLevel or the internal name
 * @param {string}     property            the property you want returned. defaults to displayName
 **
 * @returns {string}      name of the brLevel
 *
 * @example
 *   id
 internalName
 displayName
 longName
 breachboardUrl
 description
 icon
 /*

 */
export const bbGetSubscriptionLevelPropertyFromIdOrName = (levelNameOrId, property="displayName") => {
    const allProperties = Object.keys(bbDictionaryOfSubscriptionLevels[6]);
    const foundProperty = allProperties.find(element => element === property);
    if (!foundProperty) {
        console.warn("Looking for subscription level ", property, " but it wasn't found");
        return undefined;
    }

    try {
        if (typeof(levelNameOrId) === "number") {
            return bbDictionaryOfSubscriptionLevels[levelNameOrId][property]
        } else if (typeof(levelNameOrId) === "string") {
            const arrayOfSubscriptions = Object.keys(bbDictionaryOfSubscriptionLevels).map((k) => bbDictionaryOfSubscriptionLevels[k])
            const result = arrayOfSubscriptions.find(({ internalName }) => internalName === levelNameOrId);
            return result[property];
        }

    } catch(e) {
        return null
    }

}

/**
 * Summary. bbDoesCustomerHaveAccessToSubscription
 *
 * Description. returns true of the given customer has access to the given Subscription type
 *
 * @param {object}      customer              a customer object
 * @param {number}     subscriptionTypeId            id or name of the subscription
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbDoesCustomerHaveAccessToSubscription = (customer, subscriptionTypeId ) => {

    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))

        if(bbIsObject(customer) && customer.hasOwnProperty("Subscriptions")) {
            const activeSubscriptionarray = bbArrayOfActiveSubscriptions(customer);
            // console.log("bbDoesCustomerHaveAccessToSubscription found these active subscription types", activeSubscriptionarray);
            return activeSubscriptionarray.includes(subscriptionTypeId) || activeSubscriptionarray.includes(subscriptionTypeId.toString());
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return null
    }

}

/**
 * Summary. bbDoesCustomerHaveAccessToSubscriptionLevel
 *
 * Description. returns true of the given customer has access to the given Subscription type
 *
 * @param {object}      customer              a customer object
 * @param {number}     subscriptionTypeId            id or name of the subscription
 * @param {number}     subscriptionLevelId            id or name of the subscription level
 * @param {boolean}     orHigherThan            if provided, will return true if the subscription level is equal or higher than this name or id of a subscription level
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbDoesCustomerHaveAccessToSubscriptionLevel = (customer, subscriptionTypeId, subscriptionLevelId , orHigherThan = false) => {

    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))

        if(bbIsObject(customer) && customer.hasOwnProperty("Subscriptions")) {
            const activeSubscriptionarray = bbArrayOfActiveSubscriptions(customer);
            const hasSubscriptionType =  activeSubscriptionarray.includes(subscriptionTypeId) || activeSubscriptionarray.includes(subscriptionTypeId.toString());
            if(hasSubscriptionType && customer) {
                //now look for the subscription level
                //get the subscription we just found
                const theSubs = bbArrayOfActiveSubscriptions(customer, true, true, subscriptionTypeId);
                //console.log("bbDoesCustomerHaveAccessToSubscriptionLevel found these active subscriptions with subscriptionTypeId", theSubs, "When looking in","activeSubscriptionarray", activeSubscriptionarray, "when looking for ", "subscriptionTypeId", subscriptionTypeId, "subscriptionLevelId", subscriptionLevelId, "orHigherThan", orHigherThan, "customer", customer);

                for (const subscriptionId in theSubs) {
                    //if the subscription has the same type that we are looking for, check the subscription level
                    // console.log("bbDoesCustomerHaveAccessToSubscriptionLevel", "theSubs[subscriptionId].subscription_type", theSubs[subscriptionId].subscription_type, "theSubs[subscriptionId].subscription_level", theSubs[subscriptionId].subscription_level);

                    if(
                        bbIsObject(theSubs[subscriptionId])
                        && theSubs[subscriptionId].hasOwnProperty("subscription_type")
                        && theSubs[subscriptionId].hasOwnProperty("subscription_level")
                        && theSubs[subscriptionId].subscription_type.id
                        && theSubs[subscriptionId].subscription_level.id
                        && theSubs[subscriptionId].subscription_type.id === subscriptionTypeId
                        && theSubs[subscriptionId].subscription_level.id === subscriptionLevelId
                    ) {
                        //found a matching subscription
                        // console.log("Found an exact match of subscription level", theSubs[subscriptionId].subscription_level.id, "and", subscriptionLevelId);
                            return true;

                    } else if(bbIsObject(theSubs[subscriptionId])
                        && theSubs[subscriptionId].hasOwnProperty("subscription_type")
                        && theSubs[subscriptionId].hasOwnProperty("subscription_level")
                        && theSubs[subscriptionId].subscription_type.id
                        && theSubs[subscriptionId].subscription_level.id
                        && orHigherThan
                    ) {
                        //check if the level present is a higher sort order than orIsItHigherThanLevel
                        const sortValueTarget = bbGetSubscriptionLevelPropertyFromIdOrName(subscriptionLevelId, "sortOrder");
                        const sortValuePresent = bbGetSubscriptionLevelPropertyFromIdOrName(theSubs[subscriptionId].subscription_level.id, "sortOrder");

                        if(sortValuePresent >= sortValueTarget){
                            // console.log("The current subscription level is equal or higher than the target subscription level", "found", sortValuePresent, "target", sortValueTarget);
                            return true
                        } else{
                            console.log("The current subscription level is lower than the target subscription level", "found", sortValuePresent, "target", sortValueTarget);
                        }
                    }
                }

                //didn't find any matches
                return false;
            } else {
                return false
            }
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return null
    }

}


/**
 * Summary. bbDictionaryOfBreachRiskLevels
 *
 * Description. A hard coded dictionary of brLevel names, ids, etc until fetch from db
 *
 // * @property {number} key The id of the brLevel (from the db)
 // * @property {number} key.id The id of the brLevel (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} breachboardUrl URL ready to use in a Link element
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfBreachRiskLevels = {
    1 : {
        id: 1,
        value: 1,
        internalName: "infoLevel1",
        displayName: "Score",
        longName: "BreachRisk™ Score",
        label: "BreachRisk™ Score",
        breachboardUrl: "", //"/board/CIRT/external",
        breachboardUserGuideUrl: "", //"/board/userguide/MonitorModule",
        breachboardUserGuideUrlHash: "", //"MonitorSection",
        description: "Access to an organization's BreachRisk™ Score.",
        icon: <BBIconBreachRiskScore/>
    },
    2 : {
        id: 2,
        value: 2,
        internalName: "infoLevel2",
        displayName: "Report",
        longName: "BreachRisk™ Report",
        label: "BreachRisk™ Report",
        breachboardUrl: "", //"/board/CIRT/external",
        breachboardUserGuideUrl: "", //"/board/userguide/MonitorModule",
        breachboardUserGuideUrlHash: "", //"MonitorSection",
        description: "Access to an executive overview of an organization's threat vectors and findings, but without technical details.",
        icon: <BBIconGraphChart/>
    },
    3 : {
        id: 3,
        value: 3,
        internalName: "infoLevel3",
        displayName: "Tech Data",
        longName: "BreachRisk™ Technical",
        label: "BreachRisk™ Technical",
        breachboardUrl: "", //"/board/CIRT/external",
        breachboardUserGuideUrl: "", //"/board/userguide/MonitorModule",
        breachboardUserGuideUrlHash: "", //"MonitorSection",
        description: "Access to all BreachRisk™ details, including IP addresses, threat vector details, and discovered identities.",
        icon: <BBIconTechData/>
    },
    4 : {
        id: 4,
        value: 4,
        internalName: "infoLevel4",
        displayName: "Administrator",
        longName: "BreachRisk™ Administrator",
        label: "BreachRisk™ Administrator",
        breachboardUrl: "", //"/board/CIRT/external",
        breachboardUserGuideUrl: "", //"/board/userguide/MonitorModule",
        breachboardUserGuideUrlHash: "", //"MonitorSection",
        description: "Access to all BreachRisk™ details and the authority to add users, authorize testing, and modify scope.",
        icon: <BBIconAccountTrustedAgent/>
    },
}

/**
 * Summary. bbDictionaryOfEntityBreachRiskLevels
 *
 * Description. gets a dictionary of breachrisk levels for each entity
 *
 * @param {object}      authUser              a authUser object
 **
 * @returns {Array}      of BreachRiskLevelIds
 *
 * @example
 /*

 */
// export const bbDictionaryOfEntityBreachRiskLevels = (authUser) => {
//     try {
//         // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
//         const dictionaryOfBreachRiskLevels = {}
//         if(bbIsObject(authUser) && authUser.hasOwnProperty("entities")) {
//             // console.log("about to look for brLevels within authUser.BreachRiskLevels", authUser.BreachRiskLevels)
//             for (const entity of authUser.entities) {
//                 dictionaryOfBreachRiskLevels[entity.id] = entity.data_level
//             }
//             return dictionaryOfBreachRiskLevels;
//         } else {
//             console.warn("bbDictionaryOfEntityBreachRiskLevels was called but didn't pass initial checks. bbIsObject(authUser) is ", bbIsObject(authUser), "authUser.hasOwnProperty(\"brLevels\") is ", authUser.hasOwnProperty("brLevels") );
//             return null
//         }
//     } catch(e) {
//         return null
//     }
//
// }

/**
 * Summary. bbDoesUserHaveAccessToBreachRiskLevelForEntity
 *
 * Description. returns true of the given user has access to the given brLevel
 *
 * @param {object}             authUser              a authUser object
 * @param {string, number}     brLevel            id or internal name of the brLevel
 * @param {string, number}     entityId            entity that will be checked for the given brLevel
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbDoesUserHaveAccessToBreachRiskLevelForEntity = (authUser, brLevel, entityId ) => {
    // const brLevelId = bbGetBreachRiskLevelPropertyFromIdOrName(brLevel, "id");
    const brLevelValue = bbGetBreachRiskLevelPropertyFromIdOrName(brLevel, "value");

    // const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");
    // const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");

    // console.log("Evaluating if a user has access to BreachRisk Level for Entity", "authUser", authUser, "brLevel", brLevel, "entityId", entityId, "brLevelValue", brLevelValue)

    try {
        // console.log("bbDoesUserHaveAccessToBreachRiskLevelForEntity bbIsObject(authUser) is ", authUser, bbIsObject(authUser))

        //check for admin/staff and return true
        if(isAdmin || isStaff) {
            // console.log("User has access because is admin or staff");
            return true;
        } else if(bbIsObject(authUser) && authUser.hasOwnProperty("entities") && entityId && Array.isArray(authUser.entities)) {
            // console.group("Checking for brLevel", brLevel, "from entity", entityId);
            const userEntity = authUser.entities.find(entity => entity.entity === entityId);
            // console.log("Checking for brLevel", brLevel, "from entity", userEntity.customer.Name);
            // console.log("Looking for entityId of ", entityId, "and found this entity", userEntity);

            if (userEntity && userEntity.data_level) {
                // console.log("Checking to see if this user has a data level of", brLevelValue)
                if (userEntity.data_level >= brLevelValue) {
                    // console.log("This user's data level is ", userEntity.data_level, "returning true");
                    // console.groupEnd();
                    return true;
                } else {
                    // console.log("This user's data level is ", userEntity.data_level, "returning false");
                    // console.groupEnd();
                    return false;
                }
            } else {
                // console.log("No user entity or data_level returning null", userEntity);
                // console.groupEnd();
                return null;
            }
        } else {
            console.warn("authUser is not an object according to bbIsObject", authUser, bbIsObject(authUser) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        console.warn("Problem when bbDoesUserHaveAccessToBreachRiskLevelForEntity", e);
        return null
    }

}

/**
 * Summary. bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity
 *
 * Description. returns true of the given user has access to the given brLevel for any associated entity
 *
 * @param {object}             authUser              a authUser object
 * @param {string, number}     brLevel            id or internal name of the brLevel
 **
 * @returns {boolean}      true if has access to the given data level for any entity within .entities
 *
 * @example
 /*

 */
export const bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity = (authUser, brLevel) => {
    // const brLevelId = bbGetBreachRiskLevelPropertyFromIdOrName(brLevel, "id");
    const brLevelValue = bbGetBreachRiskLevelPropertyFromIdOrName(brLevel, "value");

    // const isPartner = isCurrentUserMemberOf(authUser, "partner");
    // const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    // const isStaff = isCurrentUserMemberOf(authUser, "staff");
    // const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");

    // console.log("Evaluating if a user has access to BreachRisk Level for Entity", "authUser", authUser, "brLevel", brLevel, "entityId", entityId, "brLevelValue", brLevelValue)

    try {
        // console.log("bbDoesUserHaveAccessToBreachRiskLevelForEntity bbIsObject(authUser) is ", authUser, bbIsObject(authUser))

        if(bbIsObject(authUser) && authUser.hasOwnProperty("entities") && Array.isArray(authUser.entities)) {

            const userEntities = authUser.entities;
            // console.group("Checking for brLevel", brLevel, "for authUser", authUser, "from entities", userEntities);
            // console.log("Checking for brLevel", brLevel, "from entity", userEntity.customer.Name);
            // console.log("Looking for entityId of ", entityId, "and found this entity", userEntity);

            //go through each array until you find one that's true
            for(const entity of userEntities) {
                // console.log("Looking at entity", entity);
                const managerFlag = entity && entity.hasOwnProperty("manager") ? entity.manager : null;
                const notAManager =  typeof managerFlag !== "undefined" && managerFlag !== null && !managerFlag;
                // console.log("managerFlag", managerFlag, "notAManager is", notAManager);
                if (entity && entity.data_level) {
                    if (entity.data_level >= brLevelValue && notAManager) {
                        console.log("This user's data level is ", entity.data_level, "and notAManager is",notAManager, "returning true");
                        console.groupEnd();
                        return true;
                    }
                }
            }

            //if haven't found one by now, doesn't exist
            // console.log("Did not find any non-self entities with false Manager and data level", brLevel);
            console.groupEnd();
            return false;

        } else {
            console.log("authUser is not an object according to bbIsObject", authUser, bbIsObject(authUser), authUser.hasOwnProperty("entities") && Array.isArray(authUser.entities) );
            return null
        }
    } catch(e) {
        console.warn("Problem when bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity", e);
        return null
    }

}

/**
 * Summary. bbBreachRiskLevelNameFromId
 *
 * Description. returns a string with the display name of the brLevel for a given Id
 *
 * @param {string, number}     brLevel            id of the brLevel or the internal name
 * @param {string}     property            the property you want returned
 **
 * @returns {string}      name of the brLevel
 *
 * @example
 *   id
 internalName
 displayName
 longName
 breachboardUrl
 description
 icon
 /*

 */
export const bbGetBreachRiskLevelPropertyFromIdOrName = (brLevel, property="displayName") => {
    const allBreachRiskLevelProperties = Object.keys(bbDictionaryOfBreachRiskLevels[1]);
    const foundProperty = allBreachRiskLevelProperties.find(element => element === property);
    if (!foundProperty) {
        console.warn("Looking for brLevel property ", property, " but it wasn't found");
        return undefined;
    }

    try {
        if (typeof(brLevel) === "number") {
            return bbDictionaryOfBreachRiskLevels[brLevel][property]
        } else if (typeof(brLevel) === "string") {
            const arrayOfBreachRiskLevels = Object.keys(bbDictionaryOfBreachRiskLevels).map((k) => bbDictionaryOfBreachRiskLevels[k])
            const result = arrayOfBreachRiskLevels.find(({ internalName }) => internalName === brLevel);
            return result[property];
        }

    } catch(e) {
        return null
    }

}

// /**
//  * Summary. bbDoesUserHaveAccessToBreachRiskLevel
//  *
//  * Description. returns true of the given customer has access to the given brLevel
//  *
//  * @param {object}      authUser              a customer object
//  * @param {string, number}     brLevel           id of the brLevel
//  **
//  * @returns {boolean}      true if has access
//  *
//  * @example
//  /*
//
//  */
// export const bbDoesUserHaveAccessToBreachRiskLevel = (authUser, brLevel ) => {
//     const brLevelId = bbGetBreachRiskLevelPropertyFromIdOrName(brLevel, "id");
//     // console.log("found brLevelId", brLevelId, " from ", brLevel);
//
//     try {
//         // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
//
//         if(bbIsObject(authUser) && authUser.hasOwnProperty("customers")) {
//             //check all customers
//             if (authUser.customers.length) {
//                 for (const customer in authUser.customers) {
//                     // const customerId = authUser.customers[customer].customer;
//                     // console.log("Looking for customerIds.  found ", customerId, "from", authUser.customers);
//                     const hasAccess = bbDoesCustomerHaveAccessToBreachRiskLevelForEntity(authUser.customers[customer], brLevelId);
//                     // console.log("Got ", hasAccess, "from", authUser.customers[customer]);
//                     if (hasAccess){
//                         return true;
//                     }
//                 }
//                 return false;
//             } else {
//                 return false;
//             }
//         } else {
//             // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
//             return null
//         }
//     } catch(e) {
//         return null
//     }
//
// }



/**
 * Summary. BBModuleIcon
 *
 * Description. returns true of the given customer has access to the given module
 *
 * @param {string, number}     moduleId            id of the module
 *  * @param {boolean}     isActive            if active styling should be shown
 *   * @param {string}     iconSize            size of icon, e.g. "40px"
 **
 * @returns {component}      true if has access
 *
 * @example
 /*

 */
export const BBModuleIcon = ({module, isActive = true, iconSize = "inherit", includeTooltip = false}  ) => {
    const moduleId = bbGetModulePropertyFromIdOrName(module, "id");
    // console.log("found moduleId", moduleId, " from ", module);

    try {

        let iconToUse = <BBIconHexQuestion className = "text-grey" style={{fontSize:iconSize}}/>;
        switch(moduleId) {
            case 1 :
                iconToUse = <BBIconHexModuleMonitor className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            case 3 :
                iconToUse = <BBIconHexModuleExternalThreat className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            case 2 :
                iconToUse = <BBIconHexModuleInsiderThreat className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            case 4 :
                iconToUse = <BBIconHexModuleSocial className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            case 6 :
                iconToUse = <BBIconHexModuleCompliance className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            case 7 :
                iconToUse = <BBIconHexModuleCompliance className={isActive ? "text-electric-blue" : "text-grey"} style={{fontSize:iconSize}}/>
                break;
            default:
                iconToUse = <BBIconHexQuestion className = "text-grey" style={{fontSize:iconSize}}/>
                break;
        }

        if (includeTooltip) {
            const moduleDisplayName = bbGetModulePropertyFromIdOrName(module);
            return <Tooltip title={`${moduleDisplayName} module ${isActive ? "is" : "is not"} active.`}>
                <span>
                    {iconToUse}
                </span>
            </Tooltip>
        } else {
            return iconToUse;
        }

    } catch(e) {
        return null
    }

}

/**
 * Summary. bbModuleNameFromId
 *
 * Description. returns a string with the display name of the module for a given Id
 *
 * @param {string, number}     module            id of the module or the internal name
 * @param {string}     property            the property you want returned
 **
 * @returns {string}      name of the module
 *
 * @example
 *   id
     internalName
     displayName
     longName
     breachboardUrl
     description
     icon
 /*

 */
export const bbGetModulePropertyFromIdOrName = (module, property="displayName") => {
    const allModuleProperties = Object.keys(bbDictionaryOfModules[1]);
    const foundProperty = allModuleProperties.find(element => element === property);
    if (!foundProperty) {
        console.warn("Looking for module property ", property, " but it wasn't found");
        return undefined;
    }

    try {
        if (typeof(module) === "number") {
            return bbDictionaryOfModules[module][property]
        } else if (typeof(module) === "string") {
            const arrayOfModules = Object.keys(bbDictionaryOfModules).map((k) => bbDictionaryOfModules[k])
            const result = arrayOfModules.find(({ internalName }) => internalName === module);
            return result[property];
        }

    } catch(e) {
        return null
    }

}

/**
 * Summary. bbDoesUserHaveAccessToModule
 *
 * Description. returns true of the given customer has access to the given module
 *
 * @param {object}      authUser              a customer object
 * @param {string, number}     module           id of the module
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbDoesUserHaveAccessToModule = (authUser, module ) => {
    const moduleId = bbGetModulePropertyFromIdOrName(module, "id");
    // console.log("found moduleId", moduleId, " from ", module);

    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))

        if(bbIsObject(authUser) && authUser.hasOwnProperty("customers")) {
            //check all customers
            if (authUser.customers.length) {
                for (const customer in authUser.customers) {
                    // const customerId = authUser.customers[customer].customer;
                    // console.log("Looking for customerIds.  found ", customerId, "from", authUser.customers);
                    const hasAccess = bbDoesCustomerHaveAccessToModule(authUser.customers[customer], moduleId);
                    // console.log("Got ", hasAccess, "from", authUser.customers[customer]);
                    if (hasAccess){
                        return true;
                    }
                }
                return false;
            } else {
                return false;
            }
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return null
    }

}



/**
 * Summary. bbIsRequestedAttackDetailed
 *
 * Description. deterine if this object is just a summary data for a requested attack or if it is the full version
 *
 * @param {object}      requestedAttack              a customer object
 **
 * @returns {boolean}      true if this requested attack has full details (and therefore doesn't need to be fetched for details perhaps)
 *
 * @example
 /*

 */
export const bbIsRequestedAttackDetailed = (requestedAttack ) => {
    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))
        if(bbIsObject(requestedAttack) && (requestedAttack.hasOwnProperty("Attack Command Base64") || requestedAttack.hasOwnProperty("Events"))) {
            //having these properties means its the full real deal
            return true
        } else {
            // console.log("requestedAttack is not a detailed object", requestedAttack, bbIsObject(requestedAttack)); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return false
        }
    } catch(e) {
        return null
    }

}

// /**
//  * Summary. bbFindCustomerIdAssociatedWithGivenAttackId
//  *
//  * Description. searches the given customer tree looking for the indicated attackId.  If found, returns the customerId and attackObject.
//  *
//  * @param {string}      attackId              a customer object
//  * @param {object}      customersToSearch              tree of customer objects
//  **
//  * @returns {object}      customerId: constains customer id.  attackObject: contains the attack object.
//  *
//  * @example
//  /*
//
//  */
// export const bbFindCustomerIdAssociatedWithGivenAttackId = (attackId, customersToSearch) => {
//     try {
//         if(attackId && bbIsObject(customersToSearch)) {
//             for(const customerId in customersToSearch) {
//                 //check the
//             }
//         } else {
//             // console.log("requestedAttack is not a detailed object", requestedAttack, bbIsObject(requestedAttack)); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
//             //bad input
//             return null
//         }
//
//     } catch(e) {
//         return null
//     }
// }

/**
 * Summary. bbExecuteScroll
 *
 * Description. Scroll to the indicated Ref object
 *
 * @param {object}      myRef              a ref object from useRef()
 * @param {boolean}      modifyUrl              if true it will also update the browser history
 **
 * @example
 /*

 */
// export const bbExecuteScroll = (myRef,  modifyUrl = false) => {
//     console.log("Preparing to scroll to ", myRef);
//     if (myRef && myRef.current) {
//         console.log("Scrolling to ", myRef.current);
//         myRef.current.scrollIntoView({behavior: 'smooth'});
//         // myRef.current.className = myRef.current.className + " pulse pulse-single";
//     }
//
//     //update url for a scroll
//     if(modifyUrl && myRef && myRef.current && myRef.current.id) {
//         const queryParams = new URLSearchParams(window.location.search);
//         queryParams.set("scrollTo", myRef.current.id);
//         console.log("Updating URL parameters: ", queryParams, queryParams.toString());
//         window.history.pushState(null, null,  "?"+queryParams.toString())
//     }
// }

/**
 * Summary. bbDelayedExecuteScroll
 *
 * Description. Scroll to the indicated element after a delay
 *
 * @param {object}      myRef              element
 **
 * @example
 /*

 */
// export const bbDelayedExecuteScroll = (el) => {
//     console.log("Preparing to delayed scroll to ", el);
//
//     if (el && el.scrollIntoView) {
//         setTimeout(() => {
//             // if (myRef && myRef.current) {
//             console.log("Scrolling to ", el);
//             el.scrollIntoView({behavior: 'smooth'});
//             // myRef.current.className = myRef.current.className + " pulse pulse-single";
//             // }
//         }, 500)
//     } else {
//         console.warn("No valid element to scroll to", el)
//     }
// }

/**
 * Summary. bbSortIpCompare
 *
 * Description. Sort IPv4 and or IPv6 addresses, to be used as a sort function.
 *
 * @param {string}      a              first Ip
 * @param {string}      b              second Ip
 **
 * @example
 /*

 */
export const bbSortIpCompare = (a, b) => {
    if(a && b) {
        try {
            //check to see if IPv4, if so it will split into 4 arrays
            const splitIp1 = a.split(".");
            const splitIp2 = b.split(".");

            if(splitIp1.length > 1 && splitIp2.length > 1) {
                //they are both IPv4
                // console.log("comparing two IPv4 addresses")
                const num1 = Number(splitIp1.map((num) => (`000${num}`).slice(-3) ).join(""));
                const num2 = Number(splitIp2.map((num) => (`000${num}`).slice(-3) ).join(""));
                return num1-num2;
            } else if (splitIp1.length > 1 || splitIp2.length > 1) {
                //one of them is IPv4
                return a - b
            } else {
                //neither is IPv4
                return a - b
            }
        } catch(e) {
            console.warn("Problem when attempting to compare IP addresses.")
            return null
        }
    } else {
        return null
    }
}

export const bbGetRequestedAttackStatusNameFromID = (statusId) => {
    let label = "";
    let avatar = null;
    switch(statusId){
        case 0:
            label = "Preparing"
            break;
        case 1:
            label = "Ready"
            break;
        case 2:
            label = "Ongoing"
            break;
        case 3:
            label = "No credits"
            break;
        case 4:
            label = "Breached"
            avatar=<ExitToAppSharpIcon/>
            break;
        case 5:
            label = "Defended"
            avatar=<BBIconShieldSimpleCheck/>
            break;
        case 7:
        case 6:
            label = "Aborted"
            break;
        case 8:
            label = "Partial Breach"
            avatar=<BBIconShieldSimpleWarning/>
            break;
        case 9:
            label = "Expired"
            avatar=<BBIconExpiredClock/>
            break;

        default:
            label = "Pending"
    }
    return {label: label, avatar:avatar};
}

export const BBBreachRiskSubscriptionBadge = ({
                                        subscriptionLevel= "",
                                        // subscriptionLevelPro = false,
                                        // subscriptionLevelPremium = false,
    hideTooltip=false
                                    }) => {

    let subscriptionLevelDisplayText = ""
    let displayColorString = ""
    switch (subscriptionLevel) {
        case "Pro":
        case "pro":
            subscriptionLevelDisplayText="Pro"
            displayColorString = "electric-blue-light"
            break;

        case "Premium":
        case "premium":
            subscriptionLevelDisplayText="Premium"
            displayColorString = "geekblue"
            break;

        case "Lite":
        case "lite":
            subscriptionLevelDisplayText="Lite"
            displayColorString = "lighter-gray"
            break;

        case "Free":
        case "free":
            subscriptionLevelDisplayText="Free"
            displayColorString = "lightest-gray"
            break;

        default:
            subscriptionLevelDisplayText="Pro"
            displayColorString = "electric-blue-light"
    }



    return <Tooltip title={hideTooltip ? "" : `This is a ${subscriptionLevelDisplayText} feature.`}>
                              <span>
                                <Badge
                                    color={displayColorString}
                                    className={"p-1 m-0"}
                                >{subscriptionLevelDisplayText}</Badge>
                              </span>
    </Tooltip>
}

export const BBDisableChildren = ({
                                      children,
                                      isCompact = false,
                                      isButtonSized = false,
                                      isDisabled = false,
                                      comingSoon = false,
                                      moduleRequired = null,
                                      brLevelRequired = null,
                                      brSubscriptionRequired = null,
                                      blurLevel = 3,
                                      portfolioView=false,
                                      ownershipVerified=null,
    additionalComponent = <></>
                                  }) => {

    const useStyles = makeStyles(theme => ({
        container: {
            position: "relative",
            width: "100%",
            height: "100%",
            // margin: 0,
            // padding: 0,

        },
        parent: {
            position: "absolute",
            top:0,
            left:0,
            right:0,
            bottom:0,
            // backgroundColor: "rgba(255, 255, 255, 0.25)",
            zIndex: "2000",
            borderRadius: "8px",
            pointerEvents: blurLevel > 0 ? "all" : "none",
        },
        child: {
            filter: `blur(${blurLevel}px)`,
            pointerEvents: blurLevel > 0 ? "none" : "all",
        },
        bannerContainer: {
            position: "relative",
            width: "100%",
            height: "100%",
            margin: 0,
            padding: 0,
            overflow: "visible"

        },
        banner: {
            position: "relative",
            // height: "75%",
            // width: "45%",
            minHeight: "80px",
            minWidth: "120px",
            // margin: 5,
             padding: 3,
            // padding: "4px",
            // color: "white",
            borderRadius: "5px",
            backgroundColor: "rgba(255, 255, 255, 0.80)",
            border: "solid gray 1px",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.15)",
        },
        buttonSizedBanner: {
            position: "relative",
            minHeight: "40px",
            fontSize: "20pt",
            // height: "75%",
            // width: "45%",
            //minHeight: "80px",
            //minWidth: "120px",
            // margin: 5,
            padding: 2,
            // padding: "4px",
            // color: "white",
            borderRadius: "4px",
            backgroundColor: "rgba(255, 255, 255, 0.80)",
            border: "solid gray 1px",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.15)",
        },
    }));

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    //TODO: Sarah The behavior of opening the popper in this component may not be right here. This disabled children is used for a large variety of things. It looks like the ownership popper stuff is rendered for all cases. Consider putting a isOwnershipRequired flag near the top to accompany the ownershipVerified flag. Then you would only display the ownership stuff if this component was told to.
    const handleMouseEnter = (event)=>{
        setOpen(true);
        setAnchorEl(event.currentTarget)
    }

    const classes = useStyles();
    //TODO: This isDisabled is backwards. It should be that when isDisable is true, children are not displayed.
    if(isDisabled) {
        return children
    } else {
        return <div className={classes.container}>
            <div className={classes.parent}>
            <div className={clsx(classes.bannerContainer,"row justify-content-center")}>
                <div className={"col-auto align-self-center"}>
                    <div className={clsx(isButtonSized ? classes.buttonSizedBanner : classes.banner,"row justify-content-center text-center")}>
                        <div className={`${isCompact ? "col-12 mb-1" : "col-2"} align-self-center`}>
                            <div  onMouseEnter={handleMouseEnter}
                                  onMouseLeave={()=>setOpen(false)}
                                    id={"popperAnchorOwnershipVerified"}>
                                <Tooltip title={`Feature unavailable. ${moduleRequired ? `Enable the ${bbGetModulePropertyFromIdOrName(moduleRequired)} Module to unlock this feature.` : ""} ${brLevelRequired ? `Enable ${bbGetBreachRiskLevelPropertyFromIdOrName(brLevelRequired)} to unlock this feature.` : ""}`}>
                                    <span>
                                        <BBIconLockBasic style={{fontSize: isButtonSized ? "inherit" : "xxx-large", color:"black"}}/>
                                    </span>
                                </Tooltip>
                                {ownershipVerified !== null && !ownershipVerified && brLevelRequired !== "infoLevel4" &&
                                   <OwnershipRequiredPopper open={open} anchorEl={anchorEl}/>
                                }
                                {brSubscriptionRequired && (ownershipVerified === null || ownershipVerified === true) &&
                                    <span style={{fontSize: "x-small"}}><BBBreachRiskSubscriptionBadge subscriptionLevel={brSubscriptionRequired} /></span>
                                }
                            </div>
                        </div>
                        {!isCompact &&
                            <div className={"col-10 align-self-center"}>
                                {comingSoon
                                    ? <h1>Feature Coming Soon</h1>
                                    : <h1>Feature Unavailable</h1>
                                }
                                {moduleRequired && <p>Enable the <Link to={bbGetModulePropertyFromIdOrName(moduleRequired, "breachboardUserGuideUrl")}>{bbGetModulePropertyFromIdOrName(moduleRequired)} Module</Link> to unlock this feature.</p>}
                                {(brLevelRequired && portfolioView) &&
                                <span>
                                    <p>Send a request to get access to these details, click below to go to manage portfolio to make your request or see if it's pending.</p>
                                    <Button variant="contained" color="primary" style={{ marginBottom: 15}}>
                                        <Link smooth to={{pathname: "/board/BreachRisk/Portfolio/Manage"}} style={{color: "white"}}>Manage Requests</Link>
                                    </Button>
                                </span>}
                                {(brLevelRequired && !portfolioView) &&
                                <span>
                                    <p>Send a request to get access to these details, click below to manage current data sharing requests and responses.</p>
                                    <Button variant="contained" color="primary" style={{ marginBottom: 15}}>
                                        <Link smooth to={{pathname: "/board/BreachRisk/Business/Share/Current"}} style={{color: "white"}}>Manage Sharing</Link>
                                    </Button>
                                </span>}
                                {brSubscriptionRequired && <p>You need a {brSubscriptionRequired} subscription to use this feature.</p>}
                                {additionalComponent}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
            <div className={classes.child}>
                {children}</div></div>
    }
}

export class BBObjectCounter extends Map {
    constructor(iter, key=null) {
        super();
        this.key = key || (x => x);
        for (let x of iter) {
            this.add(x);
        }
    }
    add(x) {
        x = this.key(x);
        this.set(x, (this.get(x) || 0) + 1);
    }
}

/**
 * Summary. bbIsUserManagerOfEntity
 *
 * Description. returns true of the user has manager access to the given entity
 *
 * @param {object}      authUser              a customer object
 * @param {string, number}     entityId           id of the entity
 **
 * @returns {boolean}      true if has access
 *
 * @example
 /*

 */
export const bbIsUserManagerOfEntity = (authUser, entityId ) => {
    // const moduleId = bbGetModulePropertyFromIdOrName(module, "id");
    // console.log("found moduleId", moduleId, " from ", module);

    try {
        // console.log("bbIsObject(assessmentGroup) is ", assessmentGroup, bbIsObject(assessmentGroup))

        if(bbIsObject(authUser) && authUser.hasOwnProperty("entities")) {
            //check all entities
            if (authUser.entities.length) {
                for (const entity of authUser.entities) {
                    // const customerId = authUser.customers[customer].customer;
                    // console.log("Looking for entityIds.  found ", entity.entity, "from", authUser.entities);
                    const hasAccess = entity.entity === entityId && entity.manager;
                    // console.log("Got ", hasAccess, "from", authUser.customers[customer]);
                    if (hasAccess){
                        return true;
                    }
                }
                console.log("authUser ", authUser, "does not have access to entity", entityId);
                return false;
            } else {
                return false;
            }
        } else {
            // console.log("assessmentGroup is not an object according to bbIsObject", assessmentGroup, bbIsObject(assessmentGroup), "assessments: ", stateData, bbIsObject(stateData) ); //, "bbIsObject(assessments[complianceStandardId]) for complianceStandardId", complianceStandardId, bbIsObject(assessments[complianceStandardId]));
            return null
        }
    } catch(e) {
        return null
    }

}

/**
 * Summary. bbIsEntityAwaitingFirstScoreCycle
 *
 * Description. returns true of the entity doesn't have an initial cycle to show data for
 *
 * @param {object}      entityObject              an entity object
 **
 * @returns {boolean}      true if is awaiting the first score
 *
 * @example
 * const entities = portfolios
 && portfolios[customerInView]
 ? portfolios[customerInView].entities
 : null;

 const myEntity = entities
 && entityInView
 ? entities[entityInView]
 : null;

 const isWaitingForFirstScore = bbIsEntityAwaitingFirstScoreCycle(myEntity);
 /*

 */
export const bbIsEntityAwaitingFirstScoreCycle = (entityObject ) => {
    try {
        return !entityObject.last_cycle;
    } catch(e) {
        console.log("bbIsEntityAwaitingFirstScoreCycle failed, returning null. entityObject", entityObject)
        return null
    }
}

/**
 * Summary. bbFindEntityWithinPortfolioOrSelf
 *
 * Description. Searches the given portfolio object looking in self and entities for the given entityId
 *
 * @param {string}      entityId              an entity id
 * @param {number}      entityId              an entity id
 * @param {object}      portfolioObject       The portfolio object to look search
 * @param {string}      customerIdToUse       The id of the customer in the portfolio to look
 * @param {number}      customerIdToUse       The id of the customer in the portfolio to look
 * @param {boolean}      searchPortfolioOnly       Setting to true will only search the Portfolio (not self)
 *
 **
 * @returns {object}      An Entity object if found or null if none found. Throws warning on error and returns null.
 *
 * @example
 * const {customerInView} = useSelector(({customer}) => customer);
 * const {entityInView, portfolios} = useSelector(({breachrisk}) => breachrisk);
 * const entityToUse = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

 */
export const bbFindEntityWithinPortfolioOrSelf = (entityId, portfolioObject, customerIdToUse , searchPortfolioOnly = false) => {
    //check that the portfolioObject has the expected properties
    if(bbIsObject(portfolioObject)
        && customerIdToUse
        && portfolioObject[customerIdToUse]
        && (portfolioObject[customerIdToUse].entities || portfolioObject[customerIdToUse].self))
        {
            const customerPortfolio = portfolioObject[customerIdToUse]
            //could be a well formatted portfolioObject
            try {
                //first, see if this entity is in self
                if(customerPortfolio.self
                    && customerPortfolio.self.id === entityId
                    && !searchPortfolioOnly
                ) {
                    //looks like we  found the entityId, it is self.
                    // console.log("Entity found is self.");
                    return customerPortfolio.self
                } else if (customerPortfolio.entities
                    && Object.keys(customerPortfolio.entities).includes(entityId)
                ) {
                    //looks like we found the entityId, it is in the entities (br portfolio)
                    // console.log("Entity found is in portfolio of entities.");
                    return customerPortfolio.entities[entityId];
                } else {
                    //entityId not found
                    // console.log("Entity not found. entityId", entityId, "portfolioObject", customerPortfolio);
                    return null;
                }
            } catch(e) {
                console.log("bbFindEntityWithinPortfolio failed, returning null. entityId", entityId, "portfolioObject", portfolioObject, "customerIdToUse", customerIdToUse, "searchPortfolioOnly", searchPortfolioOnly, e)
                return null
            }

        } else if (!portfolioObject || !customerIdToUse) {
            return null
         } else{
            //does not appear to be property formatted or may not have a customer there
            console.warn("bbFindEntityWithinPortfolio was given an improperly structured portfolioObject", portfolioObject)
            return null
        }
}

/**
 * Summary. bbFindSubportfolioWithinPortfolio
 *
 * Description. Searches the given portfolio object looking for the given SubportfolioId
 *
 * @param {string}      subportfolioId              an Subportfolio id
 * @param {number}      subportfolioId              an Subportfolio id
 * @param {object}      portfolioObject       The portfolio object to look search
 * @param {string}      customerIdToUse       The id of the customer in the portfolio to look
 * @param {number}      customerIdToUse       The id of the customer in the portfolio to look
 * @param {boolean}      searchPortfolioOnly       Setting to true will only search the Portfolio (not self)
 *
 **
 * @returns {object}      An Subportfolio object if found or null if none found. Throws warning on error and returns null.
 *
 * @example
 * const {customerInView} = useSelector(({customer}) => customer);
 * const {SubportfolioInView, portfolios} = useSelector(({breachrisk}) => breachrisk);
 * const SubportfolioToUse = bbFindSubportfolioWithinPortfolio(SubportfolioInView, portfolios, customerInView);

 */
export const bbFindSubportfolioWithinPortfolio = (subportfolioId, portfolioObject,) => {
    console.log("bbFindSubportfolioWithinPortfolio looking for subportfolioId", subportfolioId, "portfolioObject", portfolioObject);
    try{

        if(portfolioObject && portfolioObject.portfolios){
            const subportfolios = portfolioObject.portfolios;

            if(subportfolios && bbIsObject(subportfolios)){
                const arrayOfSubportfolios = Object.values(subportfolios);
                //now only get the subportfolio that matches the Id, or return false.
                console.log("Looking for subportfolioId", subportfolioId, "in arrayOfSubportfolios", arrayOfSubportfolios);
                const subportfolioLookingFor = arrayOfSubportfolios && Array.isArray(arrayOfSubportfolios) && arrayOfSubportfolios.find((sp)=> sp.id === subportfolioId);

                console.log("bbFindSubportfolioWithinPortfolio returning subportfolioLookingFor ", "from ", "arrayOfSubportfolios", arrayOfSubportfolios);

                return subportfolioLookingFor ? subportfolioLookingFor : false;

            }else{
                console.warn("bbFindSubportfolioWithinPortfolio subportfolios is not an object", "subportfolios", subportfolios);
            }

        } else {
            console.warn("bbFindSubportfolioWithinPortfolio failed initial object checks", "portfolioObject", portfolioObject)
        }

    } catch(e){
        console.warn("bbFindSubportfolioWithinPortfolio failed try", e);
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbGetSortedArrayOfSubportfoliosFromPortfolioObject
 *
 * Description. get an array of the subportfolios from a portfolio object
 *
 * @param {object}   portfolioObject           Description.
 *
 * @yield {type} Yielded value description.
 *
 * @return {type} Return value description.
 */
//*****************************************
export const bbGetSortedArrayOfSubportfoliosFromPortfolioObject = (portfolioObject) => {
    try{
        if(portfolioObject && portfolioObject.portfolios){
            const subportfolios = portfolioObject.portfolios;

            const arrayOfSubportfolios = subportfolios
                ? Object.values(subportfolios).sort(function(a, b) {
                    const textA = a.name.toUpperCase();
                    const textB = b.name.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                })
                : null;

            return arrayOfSubportfolios;
        } else {
            console.warn("bbGetSortedArrayOfSubportfoliosFromPortfolioObject failed initial object checks", "portfolioObject", portfolioObject);
        }

    }catch(e){
        console.warn("bbGetSortedArrayOfSubportfoliosFromPortfolioObject failed try", e);
    }
}


    /**
 * Summary. bbDictionaryOfClientStatusTags
 *
 * Description. A hard coded dictionary of client status tags
 *
 // * @property {number} key The id of the brLevel (from the db)
 // * @property {number} key.id The id of the brLevel (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} breachboardUrl URL ready to use in a Link element
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfClientStatusTags = {
    0 : {
        id: 0,
        value: 0,
        internalName: "None",
        label: "None",
        longName: "None",
        icon: null
    },
    1 : {
        id: 1,
        value: 1,
        internalName: "Acknowledged",
        label: "Acknowledged",
        longName: "Acknowledged",
        icon: null
    },
    2 : {
        id: 2,
        value: 2,
        internalName: "Identified",
        label: "Identified",
        longName: "Identified",
        icon: null
    },
    3 : {
        id: 3,
        value: 3,
        internalName: "No Action",
        label: "No Action",
        longName: "No Action",
        icon: null
    },
    4 : {
        id: 4,
        value: 4,
        internalName: "Assigned",
        label: "Assigned",
        longName: "Assigned",
        icon: null
    },
    5 : {
        id: 5,
        value: 5,
        internalName: "In Progress",
        label: "In Progress",
        longName: "In Progress",
        icon: null
    },
    6 : {
        id: 6,
        value: 6,
        internalName: "Verifying",
        label: "Verifying",
        longName: "Verifying",
        icon: null
    },
    7 : {
        id: 7,
        value: 7,
        internalName: "Blocked",
        label: "Blocked",
        longName: "Blocked",
        icon: null
    },
    8 : {
        id: 8,
        value: 8,
        internalName: "Waiting",
        label: "Waiting",
        longName: "Waiting",
        icon: null
    },
    9 : {
        id: 9,
        value: 9,
        internalName: "Resolved",
        label: "Resolved",
        longName: "Resolved",
        icon: null
    },
    10 : {
        id: 10,
        value: 10,
        internalName: "Closed",
        label: "Closed",
        longName: "Closed",
        icon: null
    },
}

/**
 * Summary. bbFindUserTagsByTagId
 *
 * Description. Function takes in authUser Object and tag type (id) and returns an array with tags of that type.
 *
 * @param {object}      authUser              authUser object
 * @param {number}      tagId              tag id corresponding to tag definition
 *
 * @returns {array}      An array with all user tag objects with the selected tag definition id.
 *
 * @example
 * const {authUser} = useSelector(({auth}) => auth.authUser);
 * const tagId = 38;
 *
 * const userLanguageTags = bbFindUserTagsByTagId(authUser, tagId);
 *
 * **/

export const bbFindUserTagsByTagId = (authUser, tagId) => {
    //this removes any "success" tags in the tags object, must be done first,
    // since these objects don't have the same structure as the ones we will filter

    // const filteredUserTags = authUser
    //     && authUser.user
    //     && authUser.user.tags
    //     && Object.values(authUser.user.tags)
    //         .filter((tag)=> !tag.success);

    const selectedTags = authUser
            && authUser.user
            && authUser.user.tags
            ? Object.values(authUser.user.tags)
            .filter((tag)=> tag.definition.id === tagId)
        : null;

    const activeTags = selectedTags
        ? selectedTags
            .filter((tag)=> tag.is_active)
        : null;

    return activeTags

}

/**
 * Summary. bbFindCustomerTagsByTagId
 *
 * Description. Function takes in authUser Object and tag type (id) and returns an array with tags of that type.
 *
 * @param {object}      customer              customer object
 * @param {number}      tagId              tag id corresponding to tag definition
 *
 * @returns {array}      An array with all user tag objects with the selected tag definition id.
 *
 * @example
 * const {authUser} = useSelector(({auth}) => auth.authUser);
 * const tagId = 38;
 *
 * const userLanguageTags = bbFindUserTagsByTagId(authUser, tagId);
 *
 * **/

export const bbFindCustomerTagsByTagId = (customer, tagId) => {
    // console.log("bbFindCustomerTagsByTagId with ", "customer", customer, "tagId", tagId)
    //this removes any "success" tags in the tags object, must be done first,
    // since these objects don't have the same structure as the ones we will filter

    const selectedTags = customer
    && customer.Tags
        ? Object.values(customer.Tags)
            .filter((tag)=> tag.definition.id === tagId)
        : null;

    const activeTags = selectedTags
        ? selectedTags
            .filter((tag)=> tag.is_active)
        : null;

    return activeTags
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbGetCustomHomepageUrl
 *
 * Description. Get the homepage URL if there is a custom homepage. Null if is none.
 *
 * @param {array}   arrayOfHomepageTags           an array of homepage tags from bbFindUserTagsByTagId.
 *
 * @return {string} String of the URL that user should be sent to. Null if is none.
 */
//*****************************************
export const bbGetCustomHomepageUrl = (arrayOfHomepageTags) => {

    //initial checks to see if valid array
    //id of a homepage tag is 52
    // console.log("Checking for a customer homepage URL from tags:", arrayOfHomepageTags)
    if(
        Array.isArray(arrayOfHomepageTags)
        && arrayOfHomepageTags.length > 0
        && arrayOfHomepageTags[0]
        && arrayOfHomepageTags[0].id
        && arrayOfHomepageTags[0].definition
        && arrayOfHomepageTags[0].definition.id === 52
    ) {
        try{
            //if there is more than one, take the most recent one
            const tagToUse = arrayOfHomepageTags.length > 1
                ? arrayOfHomepageTags.pop() //TODO: sort by date and take the most recent one
                : arrayOfHomepageTags.pop()

            if (tagToUse.is_active) {

                const pageItem = bbDictionaryOfCustomHomePages[tagToUse.details];

                return pageItem
                    && pageItem.hasOwnProperty("url")
                        ? pageItem.url
                        : null;
                
            } else {
                return null;
            }
        } catch (e) {
            console.warn("Something went wrong in bbGetCustomHomepage", arrayOfHomepageTags);
            return undefined;
        }

    } else {
        console.warn("bbGetCustomHomepage was sent an invalid array of homepage tags", arrayOfHomepageTags);
        return undefined;
    }
}

/**
 * Summary. bbFindCustomerTagsById
 *
 * Description. Function takes in customer object and tag type (id) and returns an array with tags of that type.
 *
 * @param {object}      customer            customer object
 * @param {number}      tagId              tag id corresponding to tag definition
 *
 * @returns {array}      An array with all active customer tag objects with the selected tag definition id.
 *
 * @example
 * const customer = customers[customerInView]
 * const tagId = 38;
 *
 * const earlyAccessTagsCustomer = bbFindCustomerTagsByTagId(customer, 53);
 *
 * **/

export const bbFindCustomerTagsById = (customer, tagId) => {

    //this removes any "success" tags in the tags object, must be done first,
    // since these objects don't have the same structure as the ones we will filter

    // const filteredTags = customer
    //     && customer.Tags
    //     && Object.values(customer.Tags)
    //         .filter((tag)=> !tag.success);

    const selectedTags = customer
        && customer.Tags
        ?  Object.values(customer.Tags)
            .filter((tag)=> tag.definition.id === tagId)
        : null;

    const activeTags = selectedTags
        ? selectedTags
            .filter((tag)=> tag.is_active)
        : null;

    return activeTags;
}

export const bbFindHasEntityTagsById = (entityObj, tagId) => {
    //entity tags may need to be updated later, as of Sep 2022, they were stored as an array of id's only

    const selectedTags = entityObj
    && entityObj.tags
        ? entityObj.tags.filter((tag)=> tag === tagId)
        : null;

    return Array.isArray(selectedTags) && selectedTags.length > 0;
}


/**
 * Summary. bbDictionaryOfCustomHomePages
 *
 * Description. A hard coded dictionary of custom home page selections
 *
 // * @property {number} key The id of the brLevel (from the db)
 // * @property {number} key.id The id of the brLevel (from the db)
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} breachboardUrl URL ready to use in a Link element
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfCustomHomePages = {

    0: {
        id: 0,
        value: 0,
        internalName: "None",
        label: "None",
        longName: "",
        url: null,
        icon: null
    },

    1: {
        id: 1,
        value: 1,
        internalName: "CIRT Dashboard",
        label: "CIRT Dashboard",
        longName: "",
        url: "/board/dashboard",
        icon: null
    },

    2: {
        id: 2,
        value: 2,
        internalName: "CIRT_external",
        label: "CIRT External Threat",
        longName: "",
        url: "/board/CIRT/external",
        icon: null
    },

    3: {
        id: 3,
        value: 3,
        internalName: "CIRT_insider",
        label: "CIRT Insider",
        longName: "",
        url: "/board/CIRT/internal",
        icon: null
    },

    4: {
        id: 4,
        value: 4,
        internalName: "BRfB_score",
        label: "Your BreachRisk™ Score",
        longName: "",
        url: "/board/BreachRisk/Business/Score",
        icon: null
    },

    5: {
        id: 5,
        value: 5,
        internalName: "BRfB_report",
        label: "Your BreachRisk™ Report",
        longName: "",
        url: "/board/BreachRisk/Business/Report/Overview",
        icon: null
    },

    6: {
        id: 6,
        value: 6,
        internalName: "BRfB_techData",
        label: "Your BreachRisk™ Technical Data",
        longName: "",
        url: "/board/BreachRisk/Business/Report/TechData",
        icon: null
    },

    7: {
        id: 7,
        value: 7,
        internalName: "Attestations",
        label: "Attestations",
        longName: "",
        url: "/board/BreachRisk/Business/Attestations",
        icon: null
    },

    9: {
        id: 9,
        value: 9,
        internalName: "Portfolio Overview",
        label: "Portfolio Overview",
        longName: "",
        url: "/board/BreachRisk/Portfolio/Insights",
        icon: null
    },

    10: {
        id: 10,
        value: 10,
        internalName: "Portfolio Score Pages",
        label: "Portfolio Scores",
        longName: "",
        url: "/board/BreachRisk/Portfolio/Details/Scores",
        icon: null
    },
    11: {
        id: 11,
        value: 11,
        internalName: "Portfolio Report Pages",
        label: "Portfolio Reports",
        longName: "",
        url: "/board/BreachRisk/Portfolio/Details/Reports",
        icon: null
    },
    12: {
        id: 12,
        value: 12,
        internalName: "Manage Portfolio",
        label: "Manage Portfolio",
        longName: "",
        url: "/board/BreachRisk/Portfolio/Manage",
        icon: null
    },
    13: {
        id: 13,
        value: 13,
        internalName: "Admin Dashboard",
        label: "Admin Dashboard",
        longName: "",
        url: "/board/admin/dashboard",
        icon: null
    },
    14: {
        id: 14,
        value: 14,
        internalName: "Admin External Page",
        label: "Admin External Page",
        longName: "",
        url: "/board/admin/external",
        icon: null
    },
    15: {
        id: 15,
        value: 15,
        internalName: "Manage Users",
        label: "Manage Users",
        longName: "",
        url: "/board/admin/users",
        icon: null
    },
    16: {
        id: 16,
        value: 16,
        internalName: "Manage Clients",
        label: "Manage Clients",
        longName: "",
        url: "/board/admin/clients",
        icon: null
    },

}

/**
 * Summary. bbDictionaryOfEmailFrequencies
 *
 * Description. A hard coded dictionary of email frequency selections
 *
 // * @property {number} key The id of the frequency selection
 // * @property {string} internalName Name for reference inside react code
 // * @property {string} displayName Name suitable for display to user
 // * @property {string} longName Longer name
 // * @property {string} description More words
 // * @property {JSX} icon Icon JSX element official
 *
 * @example {
 *
 *
 * }
 * **/
export const bbDictionaryOfEmailFrequencies = {

    0: {
        id: 0,
        value: 0,
        internalName: "None",
        label: "None",
        longName: "",
        icon: null
    },

    //not ready to implement
    1: {
        id: 1,
        value: 1,
        internalName: "Everytime",
        label: "Every Time",
        longName: "Every Instance of selected events",
        icon: null
    },

    //not ready to implement
    2: {
        id: 2,
        value: 2,
        internalName: "Daily",
        label: "Daily",
        longName: "Daily email updates",
        icon: null
    },

    3: {
        id: 3,
        value: 3,
        internalName: "Weekly",
        label: "Weekly",
        longName: "Weekly",
        icon: null
    },

    4: {
        id: 4,
        value: 4,
        internalName: "Monthly",
        label: "Monthly",
        longName: "Monthly",
        icon: null
    },

    5: {
        id: 5,
        value: 5,
        internalName: "Quarterly",
        label: "Quarterly",
        longName: "Quarterly",
        icon: null
    },

}
// jfd********** `--===<>==<>==C>-<
/**
 * Summary. isObject
 *
 * Description. BB Function. Latest common ES6 guidance on checking of something is an object. Excludes arrays and nulls.
 *
 * @param {object}   item                  the variable to check if its an object

 * @return {boolean}        True if an object, false otherwise.
 */
//*****************************************
export const isObject = (item) => {
    if (
        typeof item === 'object' &&
        !Array.isArray(item) &&
        item !== null
    ) {
        return true
    } else {
        return false
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbGetApplicableCloudIntegrationsOfTypeForEntity
 *
 * Description. filter the objects of integrations for the given entity, getting those that match entity, whether active or inactive.
 *
 * @param {string}   entityId                  the id of the entity to check
 * @param {string}   integrationOptionTypeId           an object, a single cloud integration option (i.e. AWS object)
 * @param {object}   integrationRecords           an object of all applicable integration objects for the given entity
 *
 * @return {object}    Returns an object of applicable integration objects
 */
//*****************************************
export const bbGetApplicableCloudIntegrationsOfTypeForEntity = (entityId, integrationOptionTypeId, integrationRecords) => {

    //initial checks to see if valid array
    //id of a homepage tag is 52
    // console.log("Checking for a customer homepage URL from tags:", arrayOfHomepageTags)
    if(
        entityId
        && integrationOptionTypeId
        && integrationRecords
        && isObject(integrationRecords)
    ) {
        try{
            const applicableIntegrations = integrationOptionTypeId
            && integrationRecords
            && entityId
                ? filterObject(integrationRecords, (_, i) => {
                    // console.log("Evaluating ", i, " of", integrationRecords);
                    if(
                        i
                        && i.type
                        && i.type.id
                        && i.entity === entityId
                    ) {

                        return i.type.id === integrationOptionTypeId
                    }

                })
                : null;

            return applicableIntegrations;
        } catch (e) {
            console.warn("Something went wrong in bbGetApplicableCloudIntegrationsOfTypeForEntity", entityId, integrationOptionTypeId, integrationRecords);
            return undefined;
        }

    } else {
        console.warn("bbGetApplicableCloudIntegrationsOfTypeForEntity was sent an invalid array of homepage tags", entityId, integrationOptionTypeId, integrationRecords);
        return undefined;
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbIsCloudIntegrationTypeActiveForEntity
 *
 * Description. Determine if there is an active integration of the option type given
 *
 * @param {string}   entityId                  the id of the entity to check
 * @param {number}   integrationOptionTypeId           an object, a single cloud integration option (i.e. AWS object)
 * @param {object}   integrationRecords           an object of all applicable integration objects for the given entity
 *
 * @return {boolean}    True if the cloud integration option type is present in the integrations object for the given entity. Null or undefined otherwise.
 */
//*****************************************
export const bbIsCloudIntegrationTypeActiveForEntity = (entityId, integrationOptionTypeId, integrationRecords) => {

    //initial checks to see if valid array
    //id of a homepage tag is 52
    // console.log("Checking for a customer homepage URL from tags:", arrayOfHomepageTags)
    if(
        entityId
        && integrationOptionTypeId
        && integrationRecords
        && isObject(integrationRecords)
    ) {
        try{
            const applicableActiveIntegration = integrationOptionTypeId
            && integrationRecords
            && entityId
                ? filterObject(integrationRecords, (_, i) => {
                    // console.log("Evaluating ", i, " of", integrationRecords);
                    if(
                        i
                        && i.type
                        && i.type.id
                        && i.entity === entityId
                        && i.type.id === integrationOptionTypeId
                        && i.is_active
                    ) {

                        return !i.has_error
                    }
                })
                : null;

            return applicableActiveIntegration && Object.keys(applicableActiveIntegration).length > 0;
        } catch (e) {
            console.warn("Something went wrong in bbIsCloudIntegrationTypeActiveForEntity", entityId, integrationOptionTypeId, integrationRecords);
            return undefined;
        }

    } else {
        console.warn("bbIsCloudIntegrationTypeActiveForEntity was sent an invalid array of homepage tags", entityId, integrationOptionTypeId, integrationRecords);
        return undefined;
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbIsCloudIntegrationTypeActiveWithErrorsForEntity
 *
 * Description. Determine if there is an active integration of the option type given
 *
 * @param {string}   entityId                  the id of the entity to check
 * @param {number}   integrationOptionTypeId           an object, a single cloud integration option (i.e. AWS object)
 * @param {object}   integrationRecords           an object of all applicable integration objects for the given entity
 *
 * @return {boolean}    True if the cloud integration option type is present in the integrations object for the given entity. Null or undefined otherwise.
 */
//*****************************************
export const bbIsCloudIntegrationTypeActiveWithErrorsForEntity = (entityId, integrationOptionTypeId, integrationRecords) => {

    if(
        entityId
        && integrationOptionTypeId
        && integrationRecords
        && isObject(integrationRecords)
    ) {
        // try{
            const applicableActiveIntegration = integrationOptionTypeId
            && integrationRecords
            && entityId
                ? filterObject(integrationRecords, (_, i) => {
                    // console.log("Evaluating bbIsCloudIntegrationTypeActiveWithErrorsForEntity", "entityId", entityId, "integrationOptionTypeId", integrationOptionTypeId, i, " of", integrationRecords);
                    if(
                        i
                        && i.type
                        && i.type.id
                        && i.entity === entityId
                        && i.type.id === integrationOptionTypeId
                        && i.is_active
                    ) {

                        // console.log("Candidate found.")

                        return i.has_error
                    }
                    // else {
                    //     console.log("No candidates found.")
                    // }
                })
                : null;

            console.log("Found following matching integration", applicableActiveIntegration);
            return applicableActiveIntegration && Object.keys(applicableActiveIntegration).length > 0;
        // } catch (e) {
        //     console.warn("Something went wrong in bbIsCloudIntegrationTypeActiveForEntity", entityId, integrationOptionTypeId, integrationRecords);
        //     return undefined;
        // }

    } else {
        console.warn("bbIsCloudIntegrationTypeActiveForEntity was sent an invalid array of homepage tags", entityId, integrationOptionTypeId, integrationRecords);
        return undefined;
    }
}

//sarahp*********************************July.18.2022**************

export const bbFindUsersOnboardingProgress = (entityObj, userObj) => {

    const onboardingProgress = entityObj && entityObj.onboarding_progress;
    const onboardingCompleteTag = bbFindUserTagsByTagId(userObj, 46);
    const hasProSubscription = entityObj && entityObj.pro_subscription;
    const hasPremiumSubscription = entityObj && entityObj.premium_subscription;

    const progressObject = {
        0: {
            id: 0,
            name: "Ownership Verified",
            def: "ownershipVerified",
            value: onboardingProgress && onboardingProgress.verified_ownership,
            description: <p>
                To protect the security of our customers, we require proof of authority to conduct security testing
                before providing sensitive information or enabling testing.
                <BBExternalLink
                    href={`https://support.breachbits.com/knowledge/why-and-how-to-verify-your-company-with-a-dns-record`}>
                    &nbsp;Learn more about how to do this and why we require it.
                </BBExternalLink> .
            </p>,
        },
        1: {
            id: 1,
            def: "hasFirstScore",
            name: "First Score",
            value: !bbIsEntityAwaitingFirstScoreCycle(entityObj),
            description: <p>
                It all starts with your first score. Begin sharing and improving your security with a reliable and
                relatable metric when your first score is ready.
                Find your score <Link smooth to={`/board/BreachRisk/Business/Score`}>here.</Link>
            </p>,
        },
        2: {
            id: 2,
            name: "Additional IPs Added",
            def: "hasAddedIps",
            value: onboardingProgress && onboardingProgress.added_additional_ips,
            description: <>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <p>Add IPs and other resources to BreachRisk&trade; to ensure they are included in your Score&trade; and Report&trade;.&nbsp;
                            <small className={"float-right align-self-center"} style={{marginBottom: "-12px"}}>
                                <OnboardingItemNotApplicableButton text={"No IPs To Add?"} progressItem={"ipsNA"}/>
                            </small>
                        </p>
                    </div>
                </div>
                <div className={"row text-right"}>
                    <div className={"col-12 mb-1 pb-1"}>
                        <Button variant={"contained"}
                                href={`/board/BreachRisk/Business/Verifications`}>
                            Add Additional IPs
                        </Button>

                    </div>
                </div>
            </>
        },
        3: {
            id: 3,
            name: "Domains Added",
            def: "hasAddedDomains",
            value: onboardingProgress && onboardingProgress.added_additional_domains,
            description: <>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <p>Ensure additional domains are monitored and tested, add them to BreachRisk&trade; using our Verifications page.&nbsp;
                            <small className={"float-right align-self-center"} style={{marginBottom: "-12px"}}>
                                <OnboardingItemNotApplicableButton text={"No Domains To Add?"} progressItem={"domainsNA"}/>
                            </small>
                        </p>
                    </div>
                </div>
                <div className={"row text-right"}>
                    <div className={"col-12 mb-1 pb-1"}>
                        <Button variant={"contained"}
                                href={`/board/BreachRisk/Business/Verifications`}>
                            Add Domains
                        </Button>

                    </div>
                </div>
            </>
        },
        4: {
            id: 4,
            name: "Company Identities Added",
            def: "hasAddedIdentities",
            value: onboardingProgress && onboardingProgress.added_additional_identities,
            description: <>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <p>Add company personnel and emails to include in Social Engineering.&nbsp;
                            <small className={"float-right align-self-center"} style={{marginBottom: "-12px"}}>
                                <OnboardingItemNotApplicableButton text={"No Identities To Add?"} progressItem={"identitiesNA"}/>
                            </small>
                        </p>
                    </div>
                </div>
                <div className={"row text-right"}>
                    <div className={"col-12 mb-1 pb-1"}>
                        <Button variant={"contained"}
                                href={`/board/BreachRisk/Business/Verifications`}>
                            Add Identities
                        </Button>

                    </div>
                </div>
            </>
        },
        5: {
            id: 5,
            def: 'enabledCloudIntegrations',
            name: "Cloud Integrations Enabled",
            value: onboardingProgress && onboardingProgress.added_cloud_integrations,
            description: <>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <p>Automatically synchronize your cloud-based infrastructure to further increase fidelity.
                            <small className={"float-right align-self-center"} style={{marginBottom: "-12px"}}>
                                <OnboardingItemNotApplicableButton text={"No Cloud Integrations?"} progressItem={"enabledCloudIntegrations"}/>
                            </small>
                        </p>
                    </div>
                </div>
                <div className={"row text-right"}>
                    <div className={"col-12 mb-1 pb-1"}>
                        <Button variant={"contained"}
                                className={"text-center"}
                                href={`/board/BreachRisk/Business/CloudIntegration`}>
                            Get Started
                        </Button>
                    </div>
                </div>
            </>
        },
        6: {
            id: 6,
            def: "attestationsProvided",
            name: "Attestations Provided",
            value: onboardingProgress && onboardingProgress.provided_attestation,
            description: <>
                <p>Attest that the IP Addresses, Domains, and Subdomains that appear in your Verification page fully
                    describe your public IT infrastructure. </p>
                <div className={"row text-right"}>
                    <div className={"col-12 mb-1 pb-1"}>
                        <Button variant={"contained"}
                                href={`/board/BreachRisk/Business/Attestations`}>
                            Attestations
                        </Button>
                    </div>
                </div>
            </>
        },
        7: {
            id: 7,
            def: "enabledPenTesting",
            name: "Penetration Testing Enabled",
            value: onboardingProgress && onboardingProgress.enabled_pentest,
            description: <div className="col-12 tourBRHighFidelityTesting">
                <BRBusinessAttacksAuthorizedToggleSwitchWidget brSubscriptionRequired={"Pro"}/>
            </div>
        },
        8: {
            id: 8,
            def: "socialTestingEnabled",
            name: "Social Testing Enabled",
            value: onboardingProgress && onboardingProgress.enabled_social,
            description: <div className="col-12 tourBRSocialTestingAuthorization"
                              id={"riskScatterPlotOverview"} style={{width: "100%"}}>
                <BRSocialEngineeringAuthorizationWidget style={{width: "100%"}} brSubscriptionRequired={"Premium"}/>
            </div>
        },
        // userTutorialsComplete: {
        //     name:"User Tutorials Completed",
        //     value: Array.isArray(onboardingCompleteTag) && onboardingCompleteTag.length > 0,
        //     description: <p>Find product walk throughs and more on each page throughout the application. Visit the <Link smooth to={`/board/userguide?clientID=972517173`}>Interactive User's Guide</Link> and our <BBExternalLink href={"https://support.breachbits.com/knowledge"}>Knowledge Base</BBExternalLink> to learn more about services and products.</p>},
    }

    // return progressObject;
    if(hasPremiumSubscription){
        return Object.values(progressObject)
    } else if (hasProSubscription){
        return Object.values(progressObject).splice(0,8)
    } else if (!hasPremiumSubscription || !hasProSubscription){
        return Object.values(progressObject).splice(0,7)
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbAverageFromArrayOfValues
 *
 * Description. Takes an array of number or strings and returns the average
 *
 * @param {array}   inputArray           An array of values to be averaged.

 * @yield {type} Yielded value description.
 *
 * @return {type} Return value description.
 */
//*****************************************
export const bbAverageFromArrayOfValues = (inputArray) => {
    try{
        if(inputArray && Array.isArray(inputArray)) {
            if(inputArray.length > 0){
                //filter out null and undefined values
                const numbersOnly = inputArray.filter((value)=> typeof value === "number");

                console.warn("bbAverageFromArrayOfValues filtering out non-numbers from inputArray", inputArray, "got this numbersOnly", numbersOnly);

                const average = numbersOnly.reduce((a, b) => a + b) / numbersOnly.length;
                return average;
            } else {
                // zero elements of the array... return 0
                console.warn("No elements in bbAverageFromArrayOfValues. Returning average of 0");
                return 0.0
            }
        }else {
            console.warn("bbAverageFromArrayOfValues failed initial checks using inputArray",inputArray);
            return undefined;
        }
    } catch(e) {
        console.warn("Error in bbAverageFromArrayOfValues", e);
        return undefined;
    }
}

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. bbAverageFromArrayOfValues
 *
 * Description. Takes an array of number or strings and returns the average
 *
 * @param {object}   entityDataSetToUse           A dictionary of entities, like you'd get from API. Expected to be a filtered group of entities from a subportfolio in most cases.

 * @yield {type} Yielded value description.
 *
 * @return {object} An entity with some common paramenters that are the average of the given entities
 */
//*****************************************
export const bbCreateArtificialEntityForPortfolioGroupsUsing = (entityDataSetToUse) => {
    try{
        if(entityDataSetToUse && bbIsObject(entityDataSetToUse)) {
            //artificial entity used to calculate averages for portfolio groups
            const artificialAverageEntity = {
                last_cycle: {
                    score: "N/A",
                    scored_vector_likelihood_score: "N/A",
                    scored_vector_impact_score: "N/A"
                }
            }
            const backupCopyOfEntity = artificialAverageEntity;

            const dataArray = entityDataSetToUse && bbIsObject(entityDataSetToUse)
                ? Object.values(entityDataSetToUse)
                : null

            if(dataArray && Array.isArray(dataArray)){

                /*  jfd**********22.Nov.30.18:14*****
                 *   Get average scores, likelihood, impact
                     ********************** `--===<>==<>==C>-< */
                //score
                //get an array of score values
                const arrayOfScores = dataArray.map(entity => {
                    if(entity && entity.last_cycle && entity.last_cycle.score && (typeof entity.last_cycle.score === "number" || typeof entity.last_cycle.score === "string")){

                        const value = entity.last_cycle.score;
                        return typeof value !== "number" ? value : Number(value);
                    } else {
                        return null
                    }
                } )

                //get an array of likelihood values
                const arrayOfLikelihoods = dataArray.map(entity => {
                    if(entity && entity.last_cycle && entity.last_cycle.scored_vector_likelihood_score && (typeof entity.last_cycle.scored_vector_likelihood_score === "number" || typeof entity.last_cycle.scored_vector_likelihood_score === "string")){

                        const value = entity.last_cycle.scored_vector_likelihood_score;
                        return value === null
                        ? 1 //return 1 because blank/null likelihood and impact values are business-rule floored at 1.
                            : typeof value !== "number"
                                ? value
                                : Number(value);
                    } else if(entity && entity.last_cycle && entity.last_cycle.scored_vector_likelihood_score === null) {
                        return 1 //because if the value is null then there is non, so business rule says it should floor at 1
                    } else {
                        return undefined
                    }
                } )

                //get an array of impact values
                const arrayOfImpacts = dataArray.map(entity => {
                    if(entity && entity.last_cycle && entity.last_cycle.scored_vector_impact_score && (typeof entity.last_cycle.scored_vector_impact_score === "number" || typeof entity.last_cycle.scored_vector_impact_score === "string")){

                        const value = entity.last_cycle.scored_vector_impact_score;
                        return value === null
                            ? 1 //return 1 because blank/null likelihood and impact values are business-rule floored at 1.
                            : typeof value !== "number"
                                ? value
                                : Number(value);
                    } else if(entity && entity.last_cycle && entity.last_cycle.scored_vector_impact_score === null) {
                        return 1 //because if the value is null then there is non, so business rule says it should floor at 1
                    }
                    else {
                        return undefined
                    }
                } )

                console.log("In calculateAveragesAndStoreInArtificialEntity here is the arrayOfScores", arrayOfScores);

                if(arrayOfScores && Array.isArray(arrayOfScores) && arrayOfScores.length > 0){
                    const averageScore = Number(parseFloat(bbAverageFromArrayOfValues(arrayOfScores)).toFixed(1));
                    const averageLikelihood = Number(parseFloat(bbAverageFromArrayOfValues(arrayOfLikelihoods)).toFixed(1));
                    const averageImpact = Number(parseFloat(bbAverageFromArrayOfValues(arrayOfImpacts)).toFixed(1));

                    console.log("In calculateAveragesAndStoreInArtificialEntity calculated average score of", averageScore);

                    //assign
                    artificialAverageEntity.last_cycle.score = averageScore;
                    artificialAverageEntity.last_cycle.scored_vector_likelihood_score = averageLikelihood;
                    artificialAverageEntity.last_cycle.scored_vector_impact_score = averageImpact;
                    console.log("In bbCreateArtificialEntityForPortfolioGroupsUsing artificialAverageEntity is now", artificialAverageEntity, "derived from", "entityDataSetToUse", entityDataSetToUse, "dataArray", dataArray, "arrayOfScores", arrayOfScores, "averageScore", averageScore, "arrayOfLikelihoods", arrayOfLikelihoods, "averageLikelihood", averageLikelihood, "arrayOfImpacts", arrayOfImpacts, "averageImpact", averageImpact);

                    //success, return it
                    return artificialAverageEntity;


                } else {
                    console.warn("bbCreateArtificialEntityForPortfolioGroupsUsing failed to calculate average. returning backup copy", "backupCopyOfEntity", backupCopyOfEntity, "derived from data", "dataArray", dataArray, "arrayOfScores", arrayOfScores);
                    return backupCopyOfEntity;

                }
            } else {
                console.warn("bbCreateArtificialEntityForPortfolioGroupsUsing failed internal checks", "entityDataSetToUse", entityDataSetToUse, "dataArray", dataArray);
                return undefined;
            }

        } else {
            console.warn("bbCreateArtificialEntityForPortfolioGroupsUsing failed initial checks with input entityDataSetToUse of ",entityDataSetToUse);
            return undefined;
        }
    } catch(e) {
        console.warn("Error in bbCreateArtificialEntityForPortfolioGroupsUsing", e);
        return undefined;
    }
}

export const bbDictionaryOfTargetDiscoverySources = {
    0:{
        id: 0,
        description: "Data collected directly during BreachBits discovery, recon, or testing",
        name: "BreachBits Discovery",
        image: "https://resources.breachbits.co/logos%2FBreachBits_icon_darkbox.svg",
    },
    1:{
        id: 1,
        description: "Data provided to BreachBits by customer.",
        name: "Customer Provided",
        image: null,
    },
    2:{
        id: 2,
        description: "GroupSense",
        name: "Data collected using GroupSense Dark Web Intelligence integration.",
        image: null,
    },
    3:{
        id: 3,
        description: "Reconnaissance data collected from Shodan.",
        name: "Shodan",
        image: null,
    },
    4:{
        id: 4,
        description: "Subdomain details collected from SecurityTrails",
        name: "SecurityTrails",
        image: null,
    },
    5:{
        id: 5,
        description: "Identities collected from Hunter lead generation service.",
        name: "Hunter",
        image: null,
    },
    6:{
        id: 6,
        description: "Identities collected from Snov lead generation service.",
        name: "Snov",
        image: null,
    },
    7:{
        id: 7,
        description: "Data collected from an active Digital Ocean integration. ",
        name: "Digital Ocean Integration",
        image: "https://resources.breachbits.co/logos/digitalocean.png",
    },
    8:{
        id: 8,
        description: "Data collected from an active AWS integration. ",
        name: "AWS Integration",
        image: "https://resources.breachbits.co/logos/aws.png",
    },
    9:{
        id: 9,
        description: "Data collected from an active Azure integration. ",
        name: "Azure Integration",
        image: "https://resources.breachbits.co/logos/azure.png",
    },

}
//